import React, { createContext, useContext, useState, useEffect } from "react";

const dict = {
  fr: {
    nav: {
      home: "Accueil",
      features: "Fonctionnalités",
      pricing: "Tarifs",
      faq: "FAQ",
      tutorials: "Tutos",
      affiliates: "Affiliation",
      copytrading: "Copytrading",
      contact: "Contact",
      cta: "Commander",
    },
    common: {
      buy: "Acheter",
      learn_more: "En savoir plus",
      get_started: "Commencer",
      chat_with_us: "Discuter avec nous",
      back: "Retour",
      next: "Suivant",
      submit: "Valider",
      loading: "Chargement…",
      currency: "FCFA",
      detection: "détectée automatiquement selon le navigateur",
      yes: "Oui",
      no: "Non",
      site_name: "Dr Trade Bots",
      required: "Requis",
      optional: "Optionnel",
    },
    hero: {
      tagline: "EXPERT ADVISOR MT5 — INDICES SYNTHÉTIQUES / FOREX / CRYPTOS",
      title: "Le trading institutionnel,",
      title_accent: "automatisé pour vous.",
      sub: "Dr Trade Scalper Pro combine six stratégies cohabitantes innovantes (STOKY, YAO, MCB, CRT, LOKI, THF Pulse), un filtre de retournement RTA, un Smart SL intelligent et un filtre de tendance multi-timeframe. Conçu pour les traders exigeants chevronnés ou débutants.",
      cta_primary: "Voir les tarifs",
      cta_secondary: "Découvrir les fonctionnalités",
      stat1: "Stratégies cohabitantes",
      stat2: "Fonctionnalités inédites",
      stat3: "Notif. Telegram event-driven",
    },
    home: {
      cta_strip: {
        title_pre: "Prêt à scalper avec une ",
        title_accent: "précision institutionnelle",
        title_post: " ?",
        lead: "Une compilation personnalisée, livrée en 5–15 minutes, liée à votre numéro de compte MT5 quel que soit votre broker.",
        cta: "Voir les tarifs",
      },
    },
    affiliates: {
      hdr_badge: "Programme d'affiliation",
      hdr_title: "Recommandez. Recevez. Retirez vos commissions",
      hdr_lead_pre: "Partagez votre code personnel. À chaque achat ou renouvellement de licence via votre code, vous touchez ",
      hdr_lead_emph: "jusqu'à 20 %",
      hdr_lead_post: " de commission — versée en USDT ou Mobile Money.",
      tier_per_paid: "par licence payée",
      tier_1: "1 — 500 clients",
      tier_2: "501 — 1 000 clients",
      tier_3: "1 001 clients et +",
      tab_signup: "Devenir affilié",
      tab_resend: "Recevoir mon code",
      tab_dashboard: "Mon tableau de bord",
      signup_title: "Inscription au programme",
      signup_lead: "Pour être affilié, vous devez déjà être client. Nous vérifions automatiquement votre achat avec votre email + ID de commande.",
      f_fullname: "Nom complet",
      f_fullname_ph: "Jean Dupont",
      f_email: "Email (celui de votre commande)",
      f_email_ph: "vous@exemple.com",
      f_order_id: "ID de commande (reçu par email après achat)",
      f_order_id_ph: "ex : 0fc8c401-6e30-4da1-b262-343380cba455",
      f_pay_method: "Méthode de paiement de vos commissions",
      f_usdt_addr: "Adresse USDT TRC20",
      f_mm_num: "Numéro Mobile Money",
      btn_join: "Rejoindre le programme",
      err_signup: "Erreur lors de l'inscription.",
      resend_title: "Recevoir mon code d'affiliation",
      resend_lead: "Si vous êtes déjà inscrit au programme, renseignez votre email. Le code sera renvoyé à votre adresse.",
      resend_f_email: "Email utilisé lors de l'inscription affilié",
      resend_f_order: "ID de commande (optionnel mais plus sûr)",
      resend_f_order_ph: "uuid-de-votre-commande",
      resend_btn: "Me renvoyer mon code",
      auth_title: "Consulter mon tableau de bord",
      auth_lead: "Saisissez votre code d'affiliation et votre email pour voir vos commissions.",
      f_code: "Code d'affiliation",
      f_code_ph: "DTSP-XXXXXX",
      f_email_short: "Email",
      btn_dashboard: "Voir mon dashboard",
      err_creds: "Identifiants invalides",
      subtab_overview: "Vue d'ensemble",
      subtab_referrals: "Filleuls",
      subtab_payouts: "Paiements",
      subtab_marketing: "Marketing",
      hello: "Bonjour",
      share_link_label: "Votre lien de partage personnalisé",
      share_link_note: "Ce lien pré-remplit automatiquement votre code dans le checkout. Valide 30 j dans le navigateur du visiteur.",
      stat_clients: "Clients uniques parrainés",
      stat_pending: "Commissions en attente",
      stat_paid: "Commissions payées",
      commission_details: "Détail des commissions",
      no_commission: "Aucune commission pour le moment. Partagez votre code !",
      col_order: "Commande",
      col_type: "Type",
      col_client_num: "Client #",
      col_rate: "Taux",
      col_commission: "Commission",
      col_status: "Statut",
      col_date: "Date",
      type_renewal: "Renouv.",
      type_new: "Nouveau",
      status_paid: "Payée",
      status_pending: "En attente",
      ref_title: "Vos filleuls",
      ref_empty: "Aucun filleul pour le moment. Partagez votre lien !",
      ref_col_client: "Client",
      ref_col_plans: "Formules",
      ref_col_orders: "Commandes",
      ref_col_renewal: "Renouvellement ?",
      ref_col_cumul: "Commissions cumulées",
      ref_col_since: "Parrainé depuis",
      yes: "Oui",
      no: "Non",
      loading: "Chargement…",
      err_generic: "Erreur",
      po_title: "Retirer mes commissions",
      po_balance: "Solde disponible :",
      po_processing: "Délai de traitement :",
      po_processing_days: "7 jours maximum",
      po_threshold: "Seuil minimum de retrait :",
      po_threshold_short_pre: "— Il vous manque ",
      po_threshold_short_post: " FCFA pour pouvoir demander un retrait.",
      po_note: "Message (facultatif)",
      po_note_ph: "Ex : virement urgent",
      po_btn_request: "Demander un paiement",
      po_btn_pending: "Demande en cours",
      po_btn_insufficient: "Solde insuffisant",
      po_history: "Historique de mes demandes",
      po_history_empty: "Aucune demande pour l'instant.",
      po_col_amount: "Montant",
      po_col_method: "Méthode",
      po_col_wait: "Jours d'attente",
      po_col_paid_ref: "Référence paiement",
      po_st_pending: "Non traité",
      po_st_processing: "En cours",
      po_st_paid: "Traité",
      po_st_rejected: "Rejeté",
      po_success: "Demande envoyée ✓ Email de confirmation envoyé.",
      mk_title: "Vos codes de réduction",
      mk_lead_pre: "Créez vos propres codes promo pour booster votre audience. Le taux de réduction que vous accordez est ",
      mk_lead_deducted: "déduit",
      mk_lead_mid: " de votre commission. Si vous concédez ",
      mk_lead_100: "100 %",
      mk_lead_post: " de votre taux, vous touchez toujours un bonus de 5 % sur le montant payé.",
      mk_current_rate: "Votre taux de parrainage actuel :",
      mk_max_discount: " — réduction max autorisée :",
      mk_new: "Nouveau code",
      mk_cancel: "Annuler",
      mk_empty: "Aucun code promo pour l'instant. Créez-en un !",
      mk_col_code: "Code",
      mk_col_discount: "Remise",
      mk_col_validity: "Validité",
      mk_col_uses: "Utilisations",
      mk_col_actions: "Actions",
      mk_active: "Actif",
      mk_inactive: "Désactivé",
      mk_btn_deactivate: "Désactiver",
      mk_btn_activate: "Activer",
      mk_btn_delete: "Supprimer",
      mk_confirm_del: "Supprimer définitivement le code {code} ?",
      mk_f_code: "Code (facultatif, laisser vide pour auto)",
      mk_f_code_ph: "AFF-MONCODE",
      mk_f_discount: "Remise (%) — max",
      mk_f_from: "Valide du",
      mk_f_to: "Valide jusqu'au",
      mk_f_uses: "Utilisations max (vide = illimité)",
      mk_f_uses_ph: "ex: 50",
      mk_create: "Créer le code",
      su_title: "Bienvenue dans le programme !",
      su_code_label: "Votre code",
      su_link_label: "Votre lien de partage",
      su_copy_code: "Copier le code",
      su_copy_link: "Copier le lien",
      su_copied: "Copié !",
      su_share_note: "Partagez ce lien sur WhatsApp, Telegram ou Twitter : le code sera pré-rempli dans la commande de vos contacts.",
      copy_my_code: "Copier mon code",
      copy: "Copier",
      copied: "Copié !",
    },
    features: {
      overline: "FONCTIONNALITÉS",
      title: "Une boîte à outils complète pour trader sereinement",
      sub: "Chaque module est pensé pour réduire le bruit, filtrer les faux signaux et protéger votre capital.",
      list: [
        // === Ligne 1 — Stratégies ===
        { t: "Stratégie STOKY", d: "Scalping de suivi de tendances axée sur la zone de valeur du prix. Entrées millimétrées sur les phases d'impulsions/corrections avec ou sans filtre MTF. Cooldown anti-overtrading.", i: "Activity" },
        { t: "Stratégie YAO", d: "Scalping price action de convergence directionnelle. Détection de bougie de rejet (continuation + reversal). Validation en cascade et entrée dans le sens du rejet suivant la tendance MTF.", i: "Target" },
        { t: "Stratégie MCB", d: "Swing trading de figure chartiste. Détection de bougies de Momentum consécutives. Entrée au niveau de cassure confirmé et validé par la stochastique (en option).", i: "Zap" },
        { t: "Stratégie CRT", d: "Swing trading de figure chartiste. Détection de figure CRT. Entrée en mode agressif ou conservateur pour capter 100 % du potentiel de la figure.", i: "CandlestickChart" },
        { t: "Stratégie LOKI", d: "Scalping price action haute fréquence sur reversal. Détection et entrée sur pullback en mode agressif ou conservateur pour capter le potentiel des marchés volatiles.", i: "Repeat" },
        { t: "Stratégie THF Pulse", d: "Scalping price action haute fréquence intra-bougie. Détection de mouvements en deux temps sur bougies volatiles. Capture des impulsions pour maximiser le profit.", i: "Waves" },
        // === Lignes 2-3 — Modules cœur ===
        { t: "Multi-stratégie", d: "Mode Race ou Relais : STOKY, YAO, MCB, CRT, LOKI et THF Pulse peuvent cohabiter ou se relayer après un déclenchement, avec cooldown post-switch.", i: "Workflow" },
        { t: "Exit Trade", d: "Cleanup intelligent des positions négatives : marquage sur changement de tendance, clôture des positions toxiques pour éviter les lourdes pertes et saisir au plus tôt la nouvelle tendance.", i: "DoorOpen" },
        { t: "Risk Management", d: "Gestion des positions et Ordres STOP, Filtre Anti-rafale, Cooldowns transactionnels, Protection niveau de marge, Daily Target Stop Trading, Profit Lock.", i: "ShieldCheck" },
        { t: "Copytrading Master / Slave", d: "Dupliquez automatiquement les trades d'un compte Master vers plusieurs comptes Slaves simultanément. Isolation multi-groupes sécurisée par Pairing Key unique. Modes Identique / Inversé, lot Identique ou local.", i: "Copy" },
        { t: "Intérêt composé", d: "Gestion dynamique des lots : l'EA ajuste automatiquement la taille des positions en fonction du capital disponible pour capitaliser les gains. Mode lot fixe également disponible.", i: "TrendingUp" },
        { t: "Telegram event-driven", d: "Notifications enrichies temps réel : Trade ouvert, Trade clôturé avec PNL/durée, et événements Smart SL, …etc.", i: "Send" },
        { t: "Affichage graphique", d: "Panneau on-chart en temps réel : Seuils Smart SL par position, État MTF du marché, Indicateur RTA et Panneau de trading manuel rapide.", i: "MonitorSmartphone" },
        // === Ligne 4 — Filtres ===
        { t: "Filtre EZF", d: "Extreme Zone Filter : verrou directionnel zonal Stochastique. Bloque les BUY en surachat et les SELL en survente sur la TF d'exécution de chaque stratégie.", i: "Lock" },
        { t: "Filtre RTA", d: "Reversal Trend Anticipation : détection des zones de surachat/survente Stochastique + divergences RSI pour anticiper les pièges de retournement.", i: "ShieldAlert" },
        { t: "Filtre MTF Price Action", d: "Validation convergence/divergence multi-timeframe par pure analyse OHLC — Filtre de tendance fiable pour optimiser les signaux des stratégies embarquées.", i: "Layers" },
        { t: "Filtre 3MA", d: "Combinaison de moyennes mobiles configuré pour filtrer les signaux et favoriser un trading de suivi de tendance ou multidirectionnel selon le choix de l'utilisateur.", i: "Filter" },
        { t: "Structure Filter", d: "Détection des pivots swing (points hauts/bas), traçage on-chart de zones BUY/SELL. Autorise BUY uniquement dans les zones haussières, SELL uniquement dans les zones baissières.", i: "Radar" },
      ],
      compare_overline: "POURQUOI DR TRADE ?",
      compare_title: "EA standard vs Dr Trade Scalper Pro",
      compare_sub: "Là où la plupart des EA s'arrêtent à un signal d'entrée, le nôtre embarque toute la chaîne de protection.",
      compare_col_a: "EA standard",
      compare_col_b: "Dr Trade Scalper Pro",
      compare_rows: [
        { topic: "Stop Loss", a: "SL fixe et aveugle", b: "Smart SL adaptatif + trailing PNL pour réduire la perte près du break-even" },
        { topic: "Filtre tendance", a: "Souvent absent ou mono-timeframe", b: "MTF Price Action Hebdo / Daily / H4 + filtre RTA Stochastique + RSI" },
        { topic: "Stratégies", a: "Une seule stratégie, peu adaptable", b: "STOKY + YAO + MCB + CRT + LOKI + THF Pulse en mode Race ou Relay avec cooldown post-switch" },
        { topic: "Plafond de perte", a: "Hard SL fixe", b: "Hard Cap dynamique aligné automatiquement sur le seuil Smart SL" },
        { topic: "Sur-trading", a: "Aucun garde-fou", b: "Cooldown global + post-switch + 60 min après une clôture Smart SL" },
        { topic: "Notifications", a: "Push basique ou inexistant", b: "Telegram event-driven : ouverture, clôture (PNL/durée), événements Smart SL" },
        { topic: "Validation config", a: "Échec silencieux si lot trop bas", b: "Popup d'alerte au chargement si lot < min broker" },
        { topic: "Lecture du contexte", a: "À deviner sur le graphique", b: "Panneau on-chart temps réel : seuils SL, MTF, RTA, Stochastique TF_Position" },
        { topic: "Gestion des swaps", a: "Aucune compensation", b: "TP Swap Compensation : décalage automatique du TP pour compenser swap + commission cumulés et préserver le profit net escompté" },
      ],
    },
    pricing: {
      overline: "TARIFS",
      title: "Choisissez votre licence, activez votre EA en quelques heures",
      sub: "Paiement USDT (TRC20), Mobile Money (Orange, MTN, Moov) ou PayPal. Après validation du paiement, livraison manuelle par email sous 24h maximum (généralement sous 2h).",
      single: "Licence Compte Unique",
      single_sub: "2 comptes autorisés (1 démo + 1 réel)",
      multi: "Licence Compte Multiple",
      multi_sub: "Jusqu'à 6 comptes MT5",
      unlimited: "Licence Compte Illimité",
      unlimited_sub: "Comptes illimités — aucune restriction",
      duration_1m: "1 mois",
      duration_3m: "3 mois",
      duration_6m: "6 mois",
      duration_12m: "12 mois",
      save: "Économisez",
      most_popular: "LE PLUS POPULAIRE",
      cta: "Choisir cette offre",
      includes: "Inclus :",
      includes_list: [
        "Toutes les stratégies (STOKY + YAO + MCB + CRT + LOKI + THF Pulse)",
        "Filtre RTA + Smart SL + Filtre MTF",
        "Notifications Telegram event-driven",
        "Mises à jour pendant la durée",
        "Support technique prioritaire",
      ],
      note_single: "Idéal pour tester, fructifier le mois d'essai puis passer un investissement plus long terme",
      note_single_3m: "Pour traders souhaitant fructifier leur capital dans un premier temps puis passer un investissement plus long terme",
      note_single_6m: "Pour traders souhaitant passer à un investissement à moyen terme et fructifier leur capital",
      note_single_12m: "Pour traders avertis souhaitant réaliser du revenu passif et fructifier leur investissement sur le long terme",
      note_multi: "Pour traders avec plusieurs brokers ou stratégies de diversification",
      note_unlimited: "Licence sans restriction — Pour les Revendeurs et Groupes d'investissement",
      payment_methods: "Paiements sécurisés · USDT (TRC20) · CinetPay · PayPal",
    },
    faq: {
      overline: "FAQ",
      title: "Les questions qu'on nous pose",
      items: [
        { q: "Comment se déroule la livraison après paiement ?", a: "1) Vous payez via USDT, MobileMoney ou Carte Bancaire. 2) Vous remplissez un formulaire avec votre/vos numéro(s) de compte MT5. 3) Notre opérateur compile votre fichier .ex5 personnalisé en 5-15 minutes. 4) Vous recevez automatiquement le lien de téléchargement." },
        { q: "Sur quel courtier puis-je utiliser le robot ?", a: "Recommandés : Deriv, Weltrade, Exness, FBS, ... Tous brokers proposant indices synthétiques, Forex, cryptomonnaies, métaux et indices classiques." },
        { q: "Le robot fonctionne-t-il sur compte démo ?", a: "Oui, vous pouvez (et nous vous le recommandons vivement) tester notre EA sur un compte démo avant de le mettre en production sur compte réel. Vous fournirez vos vrais numéros de compte (démo et/ou réel) lors de la commande pour qu'ils soient liés à votre licence." },
        { q: "Que se passe-t-il si je change de courtier ou de numéro de compte ?", a: "Contactez le support — un changement de numéro est possible 1 fois pendant la durée de licence (sous réserve de justification)." },
        { q: "Quel capital minimum recommandez-vous ?", a: "500 USD minimum sur compte réel. Préférez les comptes ECN à spread bas pour optimiser la performance." },
        { q: "Sur quels marchés fonctionne l'EA ?", a: "L'EA est multi-marché. Il fonctionne sur les indices synthétiques (Step Index, Boom/Crash, Volatility, BreakX, FxVol, …), les paires Forex majeures et mineures, les cryptomonnaies (BTCUSD, ETHUSD…), les métaux (Or, Argent) et les indices classiques (US30, NAS100, SPX500…). Les paramètres par défaut conviennent à un scalping M1/M5 ; un léger ajustement (TP/SL/trigger cooldown) peut être utile selon la volatilité de l'instrument." },
        { q: "Y a-t-il un risque de perte ?", a: "Le trading comporte un risque de perte en capital. Le robot intègre des protections (Smart SL, RTA, filtres MTF) mais aucun système ne garantit aucune perte. N'investissez que ce que vous pouvez vous permettre de perdre." },
        { q: "Puis-je obtenir un remboursement ?", a: "Compte tenu de la nature numérique du produit (fichier .ex5 personnalisé), aucun remboursement n'est possible après livraison. Nous offrons un support technique illimité pendant la durée de la licence." },
        { q: "Mes ordres STOP se positionnent trop loin du prix actuel et ne se déclenchent jamais — que faire ?", a: "Sur certains actifs (paires exotiques, actions CFD, indices synthétiques, actifs à spread large), votre broker impose une distance minimale obligatoire entre le prix courant et un ordre en attente (paramètre SYMBOL_TRADE_STOPS_LEVEL). Cette distance peut dépasser l'offset configuré dans l'EA, ce qui empêche l'ordre de se déclencher et génère parfois l'erreur 10015 (Invalid price). Pour régler ce problème : ouvrez les inputs de l'EA, dans la section 3. Activation des stratégies, passez le paramètre Ignore_Offset_Market_Entry à true. Le robot ouvrira alors les positions directement au prix du marché (sans ordre en attente, sans offset), ce qui contourne la contrainte du broker. Laissez ce paramètre à false sur les brokers classiques (ICMarkets, Exness, FTMO…) car le mode STOP + offset reste plus discipliné et évite les entrées sur spikes." },
      ],
    },
    tutorials: {
      overline: "TUTOS CONFIGURATION",
      title: "Installez et configurez le robot en 5 min",
      downloads_title: "Documents à télécharger",
      downloads_sub: "Guides officiels PDF (v1.24) — indispensables pour une installation et une exploitation optimales.",
      download_install: "Guide d'installation",
      download_install_desc: "Procédure pas-à-pas pour installer, activer et configurer l'EA dans MT5",
      download_manual: "Manuel d'utilisation",
      download_manual_desc: "Comment utiliser le robot au quotidien : panneau on-chart, paramètres, notifications Telegram, FAQ",
      download_panel: "Guide du Panneau de Configuration",
      download_panel_desc: "Détail des 17 sections d'inputs : LOT, AUTO, STOKY, YAO, MTF, RTA, Risk, Telegram, Smart SL, Hard Cap... avec captures d'écran annotées",
      download_cta: "Télécharger PDF",
      download_size: "PDF · {size}",
      steps_title: "Étapes rapides",
      steps: [
        { t: "1. Téléchargez le fichier .ex5", d: "Après votre commande, vous recevez un lien de téléchargement sécurisé. Le fichier est nominatif et lié à vos numéros de compte MT5." },
        { t: "2. Glissez dans le dossier Experts MT5", d: "Ouvrez MetaEditor → menu File → Open Data Folder → MQL5 → Experts. Collez votre fichier .ex5 dans ce dossier." },
        { t: "3. Redémarrez MT5 et glissez l'EA sur le marché que vous souhaitez trader", d: "Ouvrez un graphique en M1 ou M5, puis glissez l'EA depuis le panneau Navigator. Activez « AutoTrading » dans la barre d'outils." },
        { t: "4. Configurez les paramètres", d: "Lot fixe ou Compound, Telegram (token + chat ID), choix des stratégies (STOKY/YAO/MCB/Multi), filtre RTA. Les valeurs par défaut sont optimisées." },
        { t: "5. Surveillez via le panneau et Telegram", d: "Le robot affiche un dashboard en temps réel sur le graphique. Recevez chaque ouverture/clôture de trade par Telegram." },
      ],
      need_help: "Besoin d'aide ? Contactez notre support via le chat ci-dessous.",
    },
    contact: {
      overline: "CONTACT",
      title: "Une question ? Écrivez-nous",
      sub: "Notre équipe vous répond sous 24h ouvrées. Pour une réponse instantanée, utilisez le chat IA en bas à droite.",
      name: "Nom complet",
      email: "Email",
      subject: "Sujet",
      message: "Votre message",
      send: "Envoyer",
      sent: "Message envoyé. Merci !",
    },
    checkout: {
      title: "Finaliser votre commande",
      back_to_pricing: "Retour aux tarifs",
      promo_label: "Code promo ou parrainage (facultatif)",
      delivery_time: "Livraison sous 24 h (généralement 2 h)",
      delivery_email: "Par email + PDF guide d'installation",
      delivery_license: "Licence personnalisée à votre nom",
      step_plan: "Plan sélectionné",
      step_info: "Vos informations",
      step_payment: "Paiement",
      step_confirm: "Confirmation",
      summary: "Récapitulatif",
      method: "Méthode de paiement",
      full_name: "Nom complet",
      email: "Email de livraison",
      phone: "Téléphone (WhatsApp de préférence)",
      broker: "Broker (optionnel)",
      mt5_accounts_label: "Comptes MT5 autorisés",
      mt5_account_n: "Compte MT5 n°",
      mt5_demo: "Compte démo",
      mt5_live: "Compte réel",
      mt5_help_single: "Saisissez votre compte démo ET votre compte réel (ou 2 comptes réels).",
      mt5_help_multi: "Saisissez jusqu'à 6 numéros de compte MT5.",
      mt5_help_unlimited: "Licence illimitée : aucun numéro de compte requis — utilisable sur tous vos comptes.",
      mt5_digits_only: "Numéro de compte : chiffres uniquement",
      payment_usdt: "USDT (TRC20)",
      payment_usdt_desc: "Crypto — transaction quasi-instantanée (~1 min)",
      payment_cinetpay: "CinetPay / Hub2",
      payment_cinetpay_desc: "Mobile money Orange/MTN/Moov, carte bancaire",
      payment_paypal: "PayPal",
      payment_paypal_desc: "Compte PayPal ou carte via PayPal",
      payment_coming_soon: "Bientôt disponible",
      payment_instructions: "Instructions de paiement",
      usdt_wallet: "Adresse USDT TRC20",
      usdt_copy: "Copier l'adresse",
      usdt_copied: "Adresse copiée !",
      usdt_qr: "Scanner le QR code",
      usdt_amount: "Montant exact à envoyer",
      usdt_note: "⚠️ Envoyez uniquement via le réseau TRC20 (Tron). Tout autre réseau est irrécupérable.",
      payment_reference: "Référence / Hash de la transaction",
      payment_reference_help: "Hash TXID (USDT), ID transaction PayPal, ou référence CinetPay",
      usdt_hash_format: "Format de hash invalide : 64 caractères hexadécimaux requis (TXID Tron).",
      usdt_hash_help: "Le hash sera vérifié automatiquement sur la blockchain Tron pour confirmer le montant et le destinataire avant validation de la commande.",
      continue_to_payment: "Continuer vers le paiement",
      back_to_info: "Modifier mes informations",
      submit_order: "Valider ma commande",
      submitting: "Envoi en cours…",
      success_title: "Commande enregistrée !",
      success_message: "Merci {name} ! Votre commande n° {id} est enregistrée. Dès confirmation de votre paiement (généralement sous 2 h, maximum 24 h), vous recevrez votre EA personnalisé par email à l'adresse {email}.",
      success_next_steps: "Prochaines étapes",
      success_step1: "Vérification du paiement par notre équipe",
      success_step2: "Compilation de votre fichier .ex5 personnalisé",
      success_step3: "Envoi par email du fichier .ex5 + guide PDF",
      success_back_home: "Retour à l'accueil",
      error_invalid: "Formulaire invalide — merci de corriger les erreurs",
      error_network: "Erreur réseau — réessayez",
    },
    chat: {
      title: "Assistant Dr Trade",
      placeholder: "Posez votre question…",
      placeholder_human: "Écrivez à notre support…",
      send: "Envoyer",
      welcome: "Bonjour ! Je suis l'assistante de Dr Trade Scalper Pro. Comment puis-je vous aider ?",
      handoff: "Parler à un humain",
      handoff_modal: "Parler à un humain",
      handoff_name: "Votre nom",
      handoff_contact: "Email ou téléphone",
      handoff_first_name: "Prénom",
      handoff_last_name: "Nom",
      handoff_email: "Adresse email",
      handoff_telegram: "Numéro/pseudo Telegram (optionnel)",
      handoff_send: "Demander un opérateur",
      send_photo: "Envoyer une photo",
      handoff_sent: "Demande envoyée. Un opérateur vous contacte sous peu.",
      handoff_sending: "Connexion au support…",
      handoff_inline_btn: "Parler à un humain",
      handoff_cta_hint: "Veuillez cliquer sur le bouton ci-dessous :",
      handoff_bridge_desc: "Un opérateur va vous répondre en direct dans ce chat. Laissez vos coordonnées pour qu'il puisse vous recontacter si besoin.",
      handoff_bridge_start: "Se connecter au support",
      status_bot: "Assistante IA",
      status_human: "Support humain en ligne",
      end_bridge: "Fermer",
      bridge_connected: "✅ Vous êtes maintenant connecté à notre support. Écrivez votre message — un opérateur vous répondra directement.",
      bridge_closed: "🔒 Votre conversation avec le support est terminée. L'assistante IA a repris la main.",
      bridge_ended_visitor: "🔒 Vous avez fermé la conversation avec le support.",
      typing: "L'assistante écrit…",
      notif_enable: "Activer les notifications pour ne pas rater les réponses",
      notif_title_alert: "Nouveau message !",
      notif_os_title: "Dr Trade — Support vous répond",
    },
    admin: {
      login: "Connexion admin",
      token: "Mot de passe admin",
      enter: "Se connecter",
      orders: "Commandes",
      contacts: "Messages contact",
      upload: "Uploader .ex5",
      uploaded: "Fichier uploadé",
      mark_status: "Changer statut",
      logout: "Déconnexion",
    },
    footer: {
      tagline: "L'EA premium qui vous génère du revenu 100 % passif,\nde manière automatisée et sécurisée.",
      legal: "Le trading implique un risque élevé de pertes et ne convient pas à tous les investisseurs. En utilisant notre EA, vous restez seul responsable de vos gains ou pertes.",
      copy: "© 2026 Dr Trade. Tous droits réservés.",
      disclaimer: "Avertissement risque",
      payments_accepted: "Paiements acceptés",
    },
  },
  en: {
    nav: {
      home: "Home",
      features: "Features",
      pricing: "Pricing",
      faq: "FAQ",
      tutorials: "Tutorials",
      affiliates: "Affiliate",
      copytrading: "Copytrading",
      contact: "Contact",
      cta: "Buy now",
    },
    common: {
      buy: "Buy",
      learn_more: "Learn more",
      get_started: "Get started",
      chat_with_us: "Chat with us",
      back: "Back",
      next: "Next",
      submit: "Submit",
      loading: "Loading…",
      currency: "XOF",
      detection: "auto-detected from browser",
      yes: "Yes",
      no: "No",
      site_name: "Dr Trade Bots",
      required: "Required",
      optional: "Optional",
    },
    hero: {
      tagline: "MT5 EXPERT ADVISOR — SYNTHETIC INDICES / FOREX / CRYPTO",
      title: "Institutional trading,",
      title_accent: "automated for you.",
      sub: "Dr Trade Scalper Pro combines six innovative cohabiting strategies (STOKY, YAO, MCB, CRT, LOKI, THF Pulse), an RTA reversal filter, an intelligent Smart SL, and a multi-timeframe trend filter. Built for demanding traders — seasoned or beginners.",
      cta_primary: "View pricing",
      cta_secondary: "Explore features",
      stat1: "Cohabiting strategies",
      stat2: "Unique features",
      stat3: "Event-driven Telegram alerts",
    },
    home: {
      cta_strip: {
        title_pre: "Ready to scalp with ",
        title_accent: "institutional precision",
        title_post: "?",
        lead: "A custom build, delivered in 5–15 minutes, bound to your MT5 account number, on any broker.",
        cta: "View pricing",
      },
    },
    affiliates: {
      hdr_badge: "Affiliate program",
      hdr_title: "Refer. Earn. Withdraw your commissions",
      hdr_lead_pre: "Share your personal code. For every licence purchase or renewal made with your code, you earn ",
      hdr_lead_emph: "up to 20 %",
      hdr_lead_post: " commission — paid in USDT or Mobile Money.",
      tier_per_paid: "per paid licence",
      tier_1: "1 — 500 clients",
      tier_2: "501 — 1,000 clients",
      tier_3: "1,001 clients and +",
      tab_signup: "Become an affiliate",
      tab_resend: "Get my code",
      tab_dashboard: "My dashboard",
      signup_title: "Program enrolment",
      signup_lead: "To become an affiliate you must already be a customer. We automatically verify your purchase using your email + order ID.",
      f_fullname: "Full name",
      f_fullname_ph: "John Doe",
      f_email: "Email (the one used for your order)",
      f_email_ph: "you@example.com",
      f_order_id: "Order ID (received by email after purchase)",
      f_order_id_ph: "e.g. 0fc8c401-6e30-4da1-b262-343380cba455",
      f_pay_method: "Payment method for your commissions",
      f_usdt_addr: "USDT TRC20 address",
      f_mm_num: "Mobile Money number",
      btn_join: "Join the program",
      err_signup: "Signup error.",
      resend_title: "Get my affiliate code",
      resend_lead: "If you are already enrolled, enter your email. The code will be re-sent to your address.",
      resend_f_email: "Email used during affiliate signup",
      resend_f_order: "Order ID (optional but safer)",
      resend_f_order_ph: "your-order-uuid",
      resend_btn: "Re-send my code",
      auth_title: "Check my dashboard",
      auth_lead: "Enter your affiliate code and your email to view your commissions.",
      f_code: "Affiliate code",
      f_code_ph: "DTSP-XXXXXX",
      f_email_short: "Email",
      btn_dashboard: "Open my dashboard",
      err_creds: "Invalid credentials",
      subtab_overview: "Overview",
      subtab_referrals: "Referrals",
      subtab_payouts: "Payouts",
      subtab_marketing: "Marketing",
      hello: "Hello",
      share_link_label: "Your personalised share link",
      share_link_note: "This link auto-fills your code at checkout. Valid for 30 days in the visitor's browser.",
      stat_clients: "Unique clients referred",
      stat_pending: "Pending commissions",
      stat_paid: "Paid commissions",
      commission_details: "Commission details",
      no_commission: "No commission yet. Share your code!",
      col_order: "Order",
      col_type: "Type",
      col_client_num: "Client #",
      col_rate: "Rate",
      col_commission: "Commission",
      col_status: "Status",
      col_date: "Date",
      type_renewal: "Renewal",
      type_new: "New",
      status_paid: "Paid",
      status_pending: "Pending",
      ref_title: "Your referrals",
      ref_empty: "No referral yet. Share your link!",
      ref_col_client: "Client",
      ref_col_plans: "Plans",
      ref_col_orders: "Orders",
      ref_col_renewal: "Renewal?",
      ref_col_cumul: "Total commissions",
      ref_col_since: "Referred since",
      yes: "Yes",
      no: "No",
      loading: "Loading…",
      err_generic: "Error",
      po_title: "Withdraw my commissions",
      po_balance: "Available balance:",
      po_processing: "Processing time:",
      po_processing_days: "7 days max",
      po_threshold: "Minimum withdrawal threshold:",
      po_threshold_short_pre: " — You still need ",
      po_threshold_short_post: " FCFA to request a withdrawal.",
      po_note: "Message (optional)",
      po_note_ph: "e.g. urgent transfer",
      po_btn_request: "Request a payout",
      po_btn_pending: "Request pending",
      po_btn_insufficient: "Balance too low",
      po_history: "My request history",
      po_history_empty: "No request yet.",
      po_col_amount: "Amount",
      po_col_method: "Method",
      po_col_wait: "Days waiting",
      po_col_paid_ref: "Payment reference",
      po_st_pending: "Untreated",
      po_st_processing: "In progress",
      po_st_paid: "Paid",
      po_st_rejected: "Rejected",
      po_success: "Request sent ✓ Confirmation email sent.",
      mk_title: "Your discount codes",
      mk_lead_pre: "Create your own promo codes to boost your audience. The discount rate you grant is ",
      mk_lead_deducted: "deducted",
      mk_lead_mid: " from your commission. If you give away ",
      mk_lead_100: "100 %",
      mk_lead_post: " of your rate, you still earn a 5 % bonus on the paid amount.",
      mk_current_rate: "Your current referral rate:",
      mk_max_discount: " — max discount allowed:",
      mk_new: "New code",
      mk_cancel: "Cancel",
      mk_empty: "No promo code yet. Create one!",
      mk_col_code: "Code",
      mk_col_discount: "Discount",
      mk_col_validity: "Validity",
      mk_col_uses: "Uses",
      mk_col_actions: "Actions",
      mk_active: "Active",
      mk_inactive: "Disabled",
      mk_btn_deactivate: "Disable",
      mk_btn_activate: "Enable",
      mk_btn_delete: "Delete",
      mk_confirm_del: "Permanently delete code {code}?",
      mk_f_code: "Code (optional, leave empty for auto)",
      mk_f_code_ph: "AFF-MYCODE",
      mk_f_discount: "Discount (%) — max",
      mk_f_from: "Valid from",
      mk_f_to: "Valid until",
      mk_f_uses: "Max uses (empty = unlimited)",
      mk_f_uses_ph: "e.g. 50",
      mk_create: "Create code",
      su_title: "Welcome to the program!",
      su_code_label: "Your code",
      su_link_label: "Your share link",
      su_copy_code: "Copy code",
      su_copy_link: "Copy link",
      su_copied: "Copied!",
      su_share_note: "Share this link on WhatsApp, Telegram or Twitter: the code will be pre-filled in your contacts' order.",
      copy_my_code: "Copy my code",
      copy: "Copy",
      copied: "Copied!",
    },
    features: {
      overline: "FEATURES",
      title: "A complete toolbox for confident trading",
      sub: "Each module is engineered to reduce noise, filter false signals, and protect your capital.",
      list: [
        // === Row 1 — Strategies ===
        { t: "STOKY Strategy", d: "Trend-following scalping focused on the price's value zone. Pinpoint entries on impulse/correction phases, with or without MTF filter. Anti-overtrading cooldown.", i: "Activity" },
        { t: "YAO Strategy", d: "Directional-convergence price-action scalping. Rejection-candle detection (continuation + reversal). Cascade validation and entry in the rejection direction aligned with the MTF trend.", i: "Target" },
        { t: "MCB Strategy", d: "Chart-pattern swing trading. Consecutive momentum-candle detection. Entry at the confirmed breakout level, validated by the Stochastic (optional).", i: "Zap" },
        { t: "CRT Strategy", d: "Chart-pattern swing trading. CRT pattern detection. Aggressive or conservative entry to capture 100% of the pattern's potential.", i: "CandlestickChart" },
        { t: "LOKI Strategy", d: "High-frequency directional-reversal price-action scalping. Detection and entry on pullback in aggressive or conservative mode to capture volatile-market potential.", i: "Repeat" },
        { t: "THF Pulse Strategy", d: "High-frequency intra-candle price-action scalping. Two-step move detection on volatile candles. Capturing impulses to maximise profit.", i: "Waves" },
        // === Rows 2-3 — Core modules ===
        { t: "Multi-strategy", d: "Race or Relay mode: STOKY, YAO, MCB, CRT, LOKI and THF Pulse can cohabit or relay each other after a trigger, with post-switch cooldown.", i: "Workflow" },
        { t: "Exit Trade", d: "Intelligent cleanup of negative positions: trend-reversal marking, closes toxic positions to avoid heavy losses and catch the new trend early.", i: "DoorOpen" },
        { t: "Risk Management", d: "Position and STOP order management, anti-burst filter, transactional cooldowns, margin-level protection, Daily Target Stop Trading, Profit Lock.", i: "ShieldCheck" },
        { t: "Master / Slave Copytrading", d: "Automatically duplicate trades from a Master account to multiple Slave accounts simultaneously. Secure multi-group isolation via unique Pairing Key. Identical / Inverted modes, Identical or local lot sizing.", i: "Copy" },
        { t: "Compound interest", d: "Dynamic lot management: the EA automatically adjusts position size based on available capital to compound gains. Fixed-lot mode also available.", i: "TrendingUp" },
        { t: "Event-driven Telegram", d: "Real-time enriched notifications: trade opened, trade closed with PNL/duration, and Smart SL events, …etc.", i: "Send" },
        { t: "Graphical display", d: "Real-time on-chart panel: Smart SL thresholds per position, MTF market state, RTA indicator, and a quick manual-trading panel.", i: "MonitorSmartphone" },
        // === Row 4 — Filters ===
        { t: "EZF Filter", d: "Extreme Zone Filter: Stochastic-based directional zone lock. Blocks BUYs in overbought and SELLs in oversold on each strategy's execution TF.", i: "Lock" },
        { t: "RTA Filter", d: "Reversal Trend Anticipation: stochastic overbought/oversold detection + RSI divergence to anticipate reversal traps.", i: "ShieldAlert" },
        { t: "MTF Price Action filter", d: "Multi-timeframe convergence/divergence validation through pure OHLC analysis — reliable trend filter to optimise the signals of the embedded strategies.", i: "Layers" },
        { t: "3MA Filter", d: "Combination of moving averages configured to filter signals and favour trend-following or multi-directional trading depending on the user's choice.", i: "Filter" },
        { t: "Structure Filter", d: "Swing pivot detection (highs/lows), on-chart BUY/SELL zone drawing. BUYs allowed only inside bullish zones, SELLs only inside bearish zones.", i: "Radar" },
      ],
      compare_overline: "WHY DR TRADE?",
      compare_title: "Standard EA vs Dr Trade Scalper Pro",
      compare_sub: "Where most EAs stop at the entry signal, ours embeds the entire protection chain.",
      compare_col_a: "Standard EA",
      compare_col_b: "Dr Trade Scalper Pro",
      compare_rows: [
        { topic: "Stop Loss", a: "Fixed, blind SL", b: "Adaptive Smart SL + trailing PNL to limit loss near break-even" },
        { topic: "Trend filter", a: "Often missing or single-timeframe", b: "MTF Price Action Weekly / Daily / H4 + RTA Stochastic + RSI filter" },
        { topic: "Strategies", a: "Single rigid strategy", b: "STOKY + YAO + MCB + CRT + LOKI + THF Pulse in Race or Relay mode with post-switch cooldown" },
        { topic: "Loss cap", a: "Fixed Hard SL", b: "Dynamic Hard Cap auto-aligned with Smart SL threshold" },
        { topic: "Over-trading", a: "No safeguards", b: "Global + post-switch + 60-min cooldown after Smart SL close" },
        { topic: "Notifications", a: "Basic or none", b: "Event-driven Telegram: open, close (P&L/duration), Smart SL events" },
        { topic: "Config validation", a: "Silent rejection if lot too low", b: "Popup alert on load if lot < broker minimum" },
        { topic: "Context awareness", a: "Guesswork on chart", b: "Real-time on-chart panel: SL thresholds, MTF, RTA, TF_Position Stochastic" },
        { topic: "Swap management", a: "No compensation", b: "TP Swap Compensation: automatic TP shift to compensate accumulated swap + commission and preserve the intended net profit" },
      ],
    },
    pricing: {
      overline: "PRICING",
      title: "Pick your licence, activate your EA within hours",
      sub: "Pay with USDT (TRC20), Mobile Money (Orange, MTN, Moov) or PayPal. After payment validation, manual delivery by email within 24 h max (typically within 2 h).",
      single: "Single Account Licence",
      single_sub: "2 accounts allowed (1 demo + 1 live)",
      multi: "Multi Account Licence",
      multi_sub: "Up to 6 MT5 accounts",
      unlimited: "Unlimited Account Licence",
      unlimited_sub: "Unlimited accounts — no restriction",
      duration_1m: "1 month",
      duration_3m: "3 months",
      duration_6m: "6 months",
      duration_12m: "12 months",
      save: "Save",
      most_popular: "MOST POPULAR",
      cta: "Choose this plan",
      includes: "Includes:",
      includes_list: [
        "All strategies (STOKY + YAO + MCB + CRT + LOKI + THF Pulse)",
        "RTA filter + Smart SL + MTF filter",
        "Event-driven Telegram alerts",
        "Updates for the entire duration",
        "Priority technical support",
      ],
      note_single: "Ideal to test, grow your capital during the trial month, then scale up with a longer-term plan",
      note_single_3m: "For traders looking to grow their capital first, then move to a longer-term investment",
      note_single_6m: "For traders ready to step into a mid-term investment and grow their capital",
      note_single_12m: "For seasoned traders looking to generate passive income and grow their investment long-term",
      note_multi: "For traders with multiple brokers or diversification strategies",
      note_unlimited: "No-restriction licence — for Resellers and Investment Groups",
      payment_methods: "Secure payments · USDT (TRC20) · CinetPay · PayPal",
    },
    faq: {
      overline: "FAQ",
      title: "Frequently asked questions",
      items: [
        { q: "How does delivery work after payment?", a: "1) You pay via USDT, Mobile Money or Credit/Debit Card. 2) You fill a form with your MT5 account number(s). 3) Our operator compiles your personalized .ex5 in 5-15 minutes. 4) You automatically receive the download link." },
        { q: "Which broker can I use?", a: "Recommended: Deriv, Weltrade, Exness, FBS, ... Any broker offering synthetic indices, Forex, cryptocurrencies, metals, and classic indices." },
        { q: "Can I run it on a demo account?", a: "Yes, you can (and we strongly recommend it) test our EA on a demo account before going live on a real account. You will provide your actual account number(s) (demo and/or live) at order time so they are linked to your license." },
        { q: "What if I change broker or account number?", a: "Contact support — a number change is possible once during the license period (subject to justification)." },
        { q: "What minimum capital do you recommend?", a: "USD 500 minimum on a live account. Prefer low-spread ECN accounts to optimise performance." },
        { q: "Which markets does the EA support?", a: "The EA is multi-market. It runs on synthetic indices (Step Index, Boom/Crash, Volatility, BreakX, FxVol, …), major/minor Forex pairs, cryptocurrencies (BTCUSD, ETHUSD…), metals (Gold, Silver) and classic indices (US30, NAS100, SPX500…). Default parameters suit M1/M5 scalping; a small tweak (TP/SL/cooldown trigger) may help adapt to the instrument's volatility." },
        { q: "Is there a risk of loss?", a: "Trading involves capital loss risk. The robot embeds protections (Smart SL, RTA, MTF filters) but no system can guarantee zero losses. Only invest what you can afford to lose." },
        { q: "Can I get a refund?", a: "Given the digital nature of the product (personalized .ex5 file), no refund is possible after delivery. We offer unlimited technical support during the license period." },
        { q: "My STOP orders sit too far from current price and never trigger — what can I do?", a: "On some assets (exotic pairs, stock CFDs, synthetic indices, wide-spread assets), your broker enforces a minimum mandatory distance between the current price and any pending order (SYMBOL_TRADE_STOPS_LEVEL). This distance may exceed the EA's configured offset, preventing the order from triggering and sometimes raising error 10015 (Invalid price). To fix it: open the EA inputs, go to section 3. Strategy activation, and set Ignore_Offset_Market_Entry to true. The robot will then open positions directly at market price (no pending order, no offset), bypassing the broker constraint. Keep this parameter set to false on standard brokers (ICMarkets, Exness, FTMO…) since the STOP + offset mode remains more disciplined and avoids entries on spikes." },
      ],
    },
    tutorials: {
      overline: "CONFIG TUTORIALS",
      title: "Install and configure the robot in 5 min",
      downloads_title: "Documents to download",
      downloads_sub: "Official PDF guides (v1.24) — essential for optimal installation and usage.",
      download_install: "Installation guide",
      download_install_desc: "Step-by-step procedure to install, activate and configure the EA in MT5",
      download_manual: "User manual",
      download_manual_desc: "How to use the robot day-to-day: on-chart panel, parameters, Telegram notifications, FAQ",
      download_panel: "Configuration Panel Guide",
      download_panel_desc: "Detailed walkthrough of the 17 input sections: LOT, AUTO, STOKY, YAO, MTF, RTA, Risk, Telegram, Smart SL, Hard Cap... with annotated screenshots",
      download_cta: "Download PDF",
      download_size: "PDF · {size}",
      steps_title: "Quick steps",
      steps: [
        { t: "1. Download the .ex5 file", d: "After ordering, you'll receive a secure download link. The file is personalized and bound to your MT5 account number(s)." },
        { t: "2. Drop into the MT5 Experts folder", d: "Open MetaEditor → File menu → Open Data Folder → MQL5 → Experts. Paste your .ex5 file there." },
        { t: "3. Restart MT5 and drop the EA on the market you want to trade", d: "Open a chart on M1 or M5, then drag the EA from the Navigator panel. Enable « AutoTrading » in the toolbar." },
        { t: "4. Configure parameters", d: "Fixed lot or Compound, Telegram (token + chat ID), strategy choice (STOKY/YAO/MCB/Multi), RTA filter. Defaults are optimized." },
        { t: "5. Monitor via panel and Telegram", d: "The robot shows a real-time dashboard on the chart. Receive every trade open/close on Telegram." },
      ],
      need_help: "Need help? Reach our support via the chat below.",
    },
    contact: {
      overline: "CONTACT",
      title: "A question? Drop us a line",
      sub: "Our team replies within 24 business hours. For an instant answer, use the AI chat at the bottom right.",
      name: "Full name",
      email: "Email",
      subject: "Subject",
      message: "Your message",
      send: "Send",
      sent: "Message sent. Thank you!",
    },
    checkout: {
      title: "Complete your order",
      back_to_pricing: "Back to pricing",
      promo_label: "Promo or referral code (optional)",
      delivery_time: "Delivery within 24 h (usually 2 h)",
      delivery_email: "By email + PDF installation guide",
      delivery_license: "Personalised licence in your name",
      step_plan: "Selected plan",
      step_info: "Your information",
      step_payment: "Payment",
      step_confirm: "Confirmation",
      summary: "Summary",
      method: "Payment method",
      full_name: "Full name",
      email: "Delivery email",
      phone: "Phone (WhatsApp preferred)",
      broker: "Broker (optional)",
      mt5_accounts_label: "Authorised MT5 accounts",
      mt5_account_n: "MT5 Account #",
      mt5_demo: "Demo account",
      mt5_live: "Live account",
      mt5_help_single: "Enter your demo account AND your live account (or 2 live accounts).",
      mt5_help_multi: "Enter up to 6 MT5 account numbers.",
      mt5_help_unlimited: "Unlimited licence: no account number required — usable on all your accounts.",
      mt5_digits_only: "Account number: digits only",
      payment_usdt: "USDT (TRC20)",
      payment_usdt_desc: "Crypto — near-instant transaction (~1 min)",
      payment_cinetpay: "CinetPay / Hub2",
      payment_cinetpay_desc: "Mobile money Orange/MTN/Moov, card",
      payment_paypal: "PayPal",
      payment_paypal_desc: "PayPal account or card via PayPal",
      payment_coming_soon: "Coming soon",
      payment_instructions: "Payment instructions",
      usdt_wallet: "USDT TRC20 address",
      usdt_copy: "Copy address",
      usdt_copied: "Address copied!",
      usdt_qr: "Scan the QR code",
      usdt_amount: "Exact amount to send",
      usdt_note: "⚠️ Send only via TRC20 (Tron) network. Any other network is unrecoverable.",
      payment_reference: "Transaction reference / Hash",
      payment_reference_help: "TXID hash (USDT), PayPal transaction ID, or CinetPay reference",
      usdt_hash_format: "Invalid hash format: 64 hexadecimal characters required (Tron TXID).",
      usdt_hash_help: "The hash will be automatically verified on the Tron blockchain to confirm the amount and recipient before order validation.",
      continue_to_payment: "Continue to payment",
      back_to_info: "Edit my information",
      submit_order: "Place my order",
      submitting: "Submitting…",
      success_title: "Order registered!",
      success_message: "Thank you {name}! Your order #{id} is registered. As soon as your payment is confirmed (typically within 2 h, max 24 h), you'll receive your personalised EA by email at {email}.",
      success_next_steps: "Next steps",
      success_step1: "Payment verification by our team",
      success_step2: "Compilation of your personalised .ex5 file",
      success_step3: "Email delivery of .ex5 file + PDF guide",
      success_back_home: "Back to home",
      error_invalid: "Invalid form — please fix the errors",
      error_network: "Network error — please retry",
    },
    chat: {
      title: "Dr Trade Assistant",
      placeholder: "Ask your question…",
      placeholder_human: "Write to our support…",
      send: "Send",
      welcome: "Hi! I'm the Dr Trade Scalper Pro assistant. How can I help?",
      handoff: "Talk to a human",
      handoff_modal: "Talk to a human",
      handoff_name: "Your name",
      handoff_contact: "Email or phone",
      handoff_first_name: "First name",
      handoff_last_name: "Last name",
      handoff_email: "Email address",
      handoff_telegram: "Telegram handle/phone (optional)",
      handoff_send: "Request operator",
      send_photo: "Send a photo",
      handoff_sent: "Request sent. An operator will contact you shortly.",
      handoff_sending: "Connecting to support…",
      handoff_inline_btn: "Talk to a human",
      handoff_cta_hint: "Please click the button below:",
      handoff_bridge_desc: "An operator will reply to you live in this chat. Leave your contact details so they can reach out if needed.",
      handoff_bridge_start: "Connect to support",
      status_bot: "AI Assistant",
      status_human: "Human support online",
      end_bridge: "Close",
      bridge_connected: "✅ You're now connected to our support team. Write your message — an operator will reply directly.",
      bridge_closed: "🔒 Your conversation with support has ended. The AI assistant is back online.",
      bridge_ended_visitor: "🔒 You have closed the conversation with support.",
      typing: "Assistant is typing…",
      notif_enable: "Enable notifications so you don't miss replies",
      notif_title_alert: "New message!",
      notif_os_title: "Dr Trade — Support replied",
    },
    admin: {
      login: "Admin login",
      token: "Admin password",
      enter: "Sign in",
      orders: "Orders",
      contacts: "Contact messages",
      upload: "Upload .ex5",
      uploaded: "File uploaded",
      mark_status: "Change status",
      logout: "Logout",
    },
    footer: {
      tagline: "The premium EA that earns you 100% passive income,\nfully automated and secure.",
      legal: "Trading involves a high risk of loss and is not suitable for all investors. By using our EA, you remain solely responsible for your gains or losses.",
      copy: "© 2026 Dr Trade. All rights reserved.",
      disclaimer: "Risk disclaimer",
      payments_accepted: "Accepted payments",
    },
  },
  es: {
    nav: {
      home: "Inicio",
      features: "Características",
      pricing: "Precios",
      faq: "FAQ",
      tutorials: "Tutoriales",
      affiliates: "Afiliación",
      copytrading: "Copytrading",
      contact: "Contacto",
      cta: "Comprar",
    },
    common: {
      buy: "Comprar",
      learn_more: "Saber más",
      get_started: "Empezar",
      chat_with_us: "Chatea con nosotros",
      back: "Volver",
      next: "Siguiente",
      submit: "Enviar",
      loading: "Cargando…",
      currency: "FCFA",
      detection: "detectado automáticamente según el navegador",
      yes: "Sí",
      no: "No",
      site_name: "Dr Trade Bots",
      required: "Requerido",
      optional: "Opcional",
    },
    hero: {
      tagline: "EXPERT ADVISOR MT5 — ÍNDICES SINTÉTICOS / FOREX / CRIPTOS",
      title: "El trading institucional,",
      title_accent: "automatizado para ti.",
      sub: "Dr Trade Scalper Pro combina seis estrategias innovadoras coexistentes (STOKY, YAO, MCB, CRT, LOKI, THF Pulse), un filtro de reversión RTA, un Smart SL inteligente y un filtro de tendencia multi-timeframe. Diseñado para traders exigentes, tanto experimentados como principiantes.",
      cta_primary: "Ver los precios",
      cta_secondary: "Descubrir las características",
      stat1: "Estrategias coexistentes",
      stat2: "Funcionalidades inéditas",
      stat3: "Notif. Telegram event-driven",
    },
    home: {
      cta_strip: {
        title_pre: "¿Listo para scalpear con ",
        title_accent: "precisión institucional",
        title_post: "?",
        lead: "Una compilación personalizada, entregada en 5–15 minutos, vinculada a tu número de cuenta MT5, sea cual sea tu bróker.",
        cta: "Ver los precios",
      },
    },
    affiliates: {
      hdr_badge: "Programa de afiliación",
      hdr_title: "Recomienda. Cobra. Retira tus comisiones",
      hdr_lead_pre: "Comparte tu código personal. Por cada compra o renovación de licencia con tu código, recibes ",
      hdr_lead_emph: "hasta el 20 %",
      hdr_lead_post: " de comisión, pagada en USDT o Mobile Money.",
      tier_per_paid: "por licencia pagada",
      tier_1: "1 — 500 clientes",
      tier_2: "501 — 1.000 clientes",
      tier_3: "1.001 clientes y +",
      tab_signup: "Hacerme afiliado",
      tab_resend: "Recibir mi código",
      tab_dashboard: "Mi panel",
      signup_title: "Inscripción al programa",
      signup_lead: "Para ser afiliado debes ser cliente. Verificamos automáticamente tu compra con tu email + ID de pedido.",
      f_fullname: "Nombre completo",
      f_fullname_ph: "Juan Pérez",
      f_email: "Email (el de tu pedido)",
      f_email_ph: "tu@ejemplo.com",
      f_order_id: "ID de pedido (recibido por email tras la compra)",
      f_order_id_ph: "ej.: 0fc8c401-6e30-4da1-b262-343380cba455",
      f_pay_method: "Método de pago de tus comisiones",
      f_usdt_addr: "Dirección USDT TRC20",
      f_mm_num: "Número Mobile Money",
      btn_join: "Unirme al programa",
      err_signup: "Error al registrarse.",
      resend_title: "Recibir mi código de afiliación",
      resend_lead: "Si ya estás inscrito, indica tu email. El código se enviará a tu dirección.",
      resend_f_email: "Email usado al inscribirse como afiliado",
      resend_f_order: "ID de pedido (opcional pero más seguro)",
      resend_f_order_ph: "uuid-de-tu-pedido",
      resend_btn: "Reenviar mi código",
      auth_title: "Consultar mi panel",
      auth_lead: "Introduce tu código de afiliación y tu email para ver tus comisiones.",
      f_code: "Código de afiliación",
      f_code_ph: "DTSP-XXXXXX",
      f_email_short: "Email",
      btn_dashboard: "Abrir mi panel",
      err_creds: "Credenciales no válidas",
      subtab_overview: "Resumen",
      subtab_referrals: "Referidos",
      subtab_payouts: "Pagos",
      subtab_marketing: "Marketing",
      hello: "Hola",
      share_link_label: "Tu enlace personalizado para compartir",
      share_link_note: "Este enlace rellena automáticamente tu código en la compra. Válido 30 días en el navegador del visitante.",
      stat_clients: "Clientes únicos referidos",
      stat_pending: "Comisiones pendientes",
      stat_paid: "Comisiones pagadas",
      commission_details: "Detalle de comisiones",
      no_commission: "Aún no hay comisiones. ¡Comparte tu código!",
      col_order: "Pedido",
      col_type: "Tipo",
      col_client_num: "Cliente #",
      col_rate: "Tasa",
      col_commission: "Comisión",
      col_status: "Estado",
      col_date: "Fecha",
      type_renewal: "Renovación",
      type_new: "Nuevo",
      status_paid: "Pagada",
      status_pending: "Pendiente",
      ref_title: "Tus referidos",
      ref_empty: "Aún no hay referidos. ¡Comparte tu enlace!",
      ref_col_client: "Cliente",
      ref_col_plans: "Planes",
      ref_col_orders: "Pedidos",
      ref_col_renewal: "¿Renovación?",
      ref_col_cumul: "Comisiones acumuladas",
      ref_col_since: "Referido desde",
      yes: "Sí",
      no: "No",
      loading: "Cargando…",
      err_generic: "Error",
      po_title: "Retirar mis comisiones",
      po_balance: "Saldo disponible:",
      po_processing: "Plazo de procesamiento:",
      po_processing_days: "7 días máximo",
      po_threshold: "Umbral mínimo de retiro:",
      po_threshold_short_pre: " — Te faltan ",
      po_threshold_short_post: " FCFA para poder solicitar un retiro.",
      po_note: "Mensaje (opcional)",
      po_note_ph: "Ej.: transferencia urgente",
      po_btn_request: "Solicitar un pago",
      po_btn_pending: "Solicitud en curso",
      po_btn_insufficient: "Saldo insuficiente",
      po_history: "Historial de mis solicitudes",
      po_history_empty: "Aún no hay solicitudes.",
      po_col_amount: "Importe",
      po_col_method: "Método",
      po_col_wait: "Días de espera",
      po_col_paid_ref: "Referencia de pago",
      po_st_pending: "No tratado",
      po_st_processing: "En curso",
      po_st_paid: "Tratado",
      po_st_rejected: "Rechazado",
      po_success: "Solicitud enviada ✓ Email de confirmación enviado.",
      mk_title: "Tus códigos de descuento",
      mk_lead_pre: "Crea tus propios códigos promo para impulsar tu audiencia. La tasa de descuento que ofreces se ",
      mk_lead_deducted: "deduce",
      mk_lead_mid: " de tu comisión. Si cedes ",
      mk_lead_100: "100 %",
      mk_lead_post: " de tu tasa, siempre obtienes un bonus del 5 % sobre el importe pagado.",
      mk_current_rate: "Tu tasa de referido actual:",
      mk_max_discount: " — descuento máximo permitido:",
      mk_new: "Nuevo código",
      mk_cancel: "Cancelar",
      mk_empty: "Aún no hay códigos promo. ¡Crea uno!",
      mk_col_code: "Código",
      mk_col_discount: "Descuento",
      mk_col_validity: "Validez",
      mk_col_uses: "Usos",
      mk_col_actions: "Acciones",
      mk_active: "Activo",
      mk_inactive: "Desactivado",
      mk_btn_deactivate: "Desactivar",
      mk_btn_activate: "Activar",
      mk_btn_delete: "Eliminar",
      mk_confirm_del: "¿Eliminar definitivamente el código {code}?",
      mk_f_code: "Código (opcional, deja vacío para auto)",
      mk_f_code_ph: "AFF-MICODIGO",
      mk_f_discount: "Descuento (%) — máx.",
      mk_f_from: "Válido desde",
      mk_f_to: "Válido hasta",
      mk_f_uses: "Usos máx. (vacío = ilimitado)",
      mk_f_uses_ph: "ej.: 50",
      mk_create: "Crear el código",
      su_title: "¡Bienvenido al programa!",
      su_code_label: "Tu código",
      su_link_label: "Tu enlace para compartir",
      su_copy_code: "Copiar el código",
      su_copy_link: "Copiar el enlace",
      su_copied: "¡Copiado!",
      su_share_note: "Comparte este enlace en WhatsApp, Telegram o Twitter: el código se rellenará automáticamente en el pedido de tus contactos.",
      copy_my_code: "Copiar mi código",
      copy: "Copiar",
      copied: "¡Copiado!",
    },
    pricing: {
      overline: "PRECIOS",
      title: "Elige tu licencia, activa tu EA en pocas horas",
      sub: "Pago con USDT (TRC20), Mobile Money (Orange, MTN, Moov) o PayPal. Tras la validación del pago, la entrega se realiza manualmente por correo electrónico en un máximo de 24 horas (generalmente en menos de 2 horas).",
      single: "Licencia de Cuenta Única",
      single_sub: "2 cuentas autorizadas (1 demo + 1 real)",
      multi: "Licencia de Cuentas Múltiples",
      multi_sub: "Hasta 6 cuentas MT5",
      unlimited: "Licencia de Cuentas Ilimitadas",
      unlimited_sub: "Cuentas ilimitadas — sin restricciones",
      duration_1m: "1 mes",
      duration_3m: "3 meses",
      duration_6m: "6 meses",
      duration_12m: "12 meses",
      save: "Ahorra",
      most_popular: "EL MÁS POPULAR",
      cta: "Elegir esta oferta",
      includes: "Incluye:",
      includes_list: [
        "Todas las estrategias (STOKY + YAO + MCB + CRT + LOKI + THF Pulse)",
        "Filtro RTA + Smart SL + Filtro MTF",
        "Notificaciones Telegram event-driven",
        "Actualizaciones durante la vigencia",
        "Soporte técnico prioritario",
      ],
      note_single: "Ideal para probar, rentabilizar el mes de prueba y luego pasar a una inversión a más largo plazo",
      note_single_3m: "Para traders que desean rentabilizar su capital primero y luego pasar a una inversión a más largo plazo",
      note_single_6m: "Para traders que desean dar el paso a una inversión a medio plazo y rentabilizar su capital",
      note_single_12m: "Para traders experimentados que desean generar ingresos pasivos y rentabilizar su inversión a largo plazo",
      note_multi: "Para traders con varios brokers o estrategias de diversificación",
      note_unlimited: "Licencia sin restricciones — Para Revendedores y Grupos de inversión",
      payment_methods: "Pagos seguros · USDT (TRC20) · CinetPay · PayPal",
    },
    contact: {
      overline: "CONTACTO",
      title: "¿Tienes una pregunta? Escríbenos",
      sub: "Nuestro equipo te responderá en 24 horas laborables. Para una respuesta instantánea, utiliza el chat de IA en la esquina inferior derecha.",
      name: "Nombre completo",
      email: "Email",
      subject: "Asunto",
      message: "Tu mensaje",
      send: "Enviar",
      sent: "Mensaje enviado. ¡Gracias!",
    },
    checkout: {
      title: "Finalizar tu pedido",
      back_to_pricing: "Volver a los precios",
      promo_label: "Código promocional o de referido (opcional)",
      delivery_time: "Entrega en menos de 24 h (generalmente 2 h)",
      delivery_email: "Por correo electrónico + PDF guía de instalación",
      delivery_license: "Licencia personalizada a tu nombre",
      step_plan: "Plan seleccionado",
      step_info: "Tus datos",
      step_payment: "Pago",
      step_confirm: "Confirmación",
      summary: "Resumen",
      method: "Método de pago",
      full_name: "Nombre completo",
      email: "Email de entrega",
      phone: "Teléfono (preferiblemente WhatsApp)",
      broker: "Broker (opcional)",
      mt5_accounts_label: "Cuentas MT5 autorizadas",
      mt5_account_n: "Cuenta MT5 n.º",
      mt5_demo: "Cuenta demo",
      mt5_live: "Cuenta real",
      mt5_help_single: "Introduce tu cuenta demo Y tu cuenta real (o 2 cuentas reales).",
      mt5_help_multi: "Introduce hasta 6 números de cuenta MT5.",
      mt5_help_unlimited: "Licencia ilimitada: no se requiere número de cuenta — utilizable en todas tus cuentas.",
      mt5_digits_only: "Número de cuenta: solo dígitos",
      payment_usdt: "USDT (TRC20)",
      payment_usdt_desc: "Cripto — transacción casi instantánea (~1 min)",
      payment_cinetpay: "CinetPay / Hub2",
      payment_cinetpay_desc: "Dinero móvil Orange/MTN/Moov, tarjeta bancaria",
      payment_paypal: "PayPal",
      payment_paypal_desc: "Cuenta de PayPal o tarjeta a través de PayPal",
      payment_coming_soon: "Próximamente disponible",
      payment_instructions: "Instrucciones de pago",
      usdt_wallet: "Dirección USDT TRC20",
      usdt_copy: "Copiar dirección",
      usdt_copied: "¡Dirección copiada!",
      usdt_qr: "Escanear el código QR",
      usdt_amount: "Cantidad exacta a enviar",
      usdt_note: "⚠️ Envía únicamente a través de la red TRC20 (Tron). Cualquier otra red es irrecuperable.",
      payment_reference: "Referencia / Hash de la transacción",
      payment_reference_help: "Hash TXID (USDT), ID de transacción de PayPal o referencia de CinetPay",
      usdt_hash_format: "Formato de hash no válido: se requieren 64 caracteres hexadecimales (TXID de Tron).",
      usdt_hash_help: "El hash se verificará automáticamente en la blockchain de Tron para confirmar el importe y el destinatario antes de validar el pedido.",
      continue_to_payment: "Continuar al pago",
      back_to_info: "Modificar mis datos",
      submit_order: "Validar mi pedido",
      submitting: "Enviando…",
      success_title: "¡Pedido registrado!",
      success_message: "¡Gracias {name}! Tu pedido n.º {id} ha sido registrado. Tras la confirmación de tu pago (generalmente en 2 h, máximo 24 h), recibirás tu EA personalizado por correo electrónico en la dirección {email}.",
      success_next_steps: "Próximos pasos",
      success_step1: "Verificación del pago por nuestro equipo",
      success_step2: "Compilación de tu archivo .ex5 personalizado",
      success_step3: "Envío por email del archivo .ex5 + guía PDF",
      success_back_home: "Volver al inicio",
      error_invalid: "Formulario no válido — por favor, corrige los errores",
      error_network: "Error de red — inténtalo de nuevo",
    },
    chat: {
      title: "Asistente Dr Trade",
      placeholder: "Haz tu pregunta…",
      placeholder_human: "Escribe a nuestro soporte…",
      send: "Enviar",
      welcome: "¡Hola! Soy la asistente de Dr Trade Scalper Pro. ¿Cómo puedo ayudarte?",
      handoff: "Hablar con un humano",
      handoff_modal: "Hablar con un humano",
      handoff_first_name: "Nombre",
      handoff_last_name: "Apellido",
      handoff_email: "Dirección de correo electrónico",
      handoff_telegram: "Número/usuario de Telegram (opcional)",
      handoff_send: "Solicitar un agente",
      send_photo: "Enviar una foto",
      handoff_sent: "Solicitud enviada. Un agente se pondrá en contacto contigo en breve.",
      handoff_sending: "Conectando con el soporte…",
      handoff_inline_btn: "Hablar con un humano",
      handoff_cta_hint: "Por favor, haz clic en el botón de abajo:",
      handoff_bridge_desc: "Un agente te responderá en directo en este chat. Deja tus datos de contacto para que pueda volver a contactarte si es necesario.",
      handoff_bridge_start: "Conectar con el soporte",
      status_bot: "Asistente de IA",
      status_human: "Soporte humano en línea",
      end_bridge: "Cerrar",
      bridge_connected: "✅ Ahora estás conectado a nuestro soporte. Escribe tu mensaje — un agente te responderá directamente.",
      bridge_closed: "🔒 Tu conversación con el soporte ha finalizado. La asistente de IA ha tomado el control de nuevo.",
      bridge_ended_visitor: "🔒 Has cerrado la conversación con el soporte.",
      typing: "La asistente está escribiendo…",
      notif_enable: "Activa las notificaciones para no perderte las respuestas",
      notif_title_alert: "¡Nuevo mensaje!",
      notif_os_title: "Dr Trade — El soporte te responde",
    },
    footer: {
      tagline: "El EA premium que te genera ingresos 100 % pasivos,\nde forma automatizada y segura.",
      legal: "El trading implica un alto riesgo de pérdidas y no es adecuado para todos los inversores. Al utilizar nuestro EA, sigues siendo el único responsable de tus ganancias o pérdidas.",
      copy: "© 2026 Dr Trade. Todos los derechos reservados.",
      disclaimer: "Aviso de riesgo",
      payments_accepted: "Pagos aceptados",
    },
    features: {
      overline: "FUNCIONALIDADES",
      title: "Un conjunto de herramientas completo para operar con tranquilidad",
      sub: "Cada módulo está diseñado para reducir el ruido, filtrar señales falsas y proteger su capital.",
      list: [
        // === Fila 1 — Estrategias ===
        {
          t: "Estrategia STOKY",
          d: "Scalping de seguimiento de tendencias centrado en la zona de valor del precio. Entradas milimétricas en fases de impulso/corrección, con o sin filtro MTF. Cooldown anti-sobreoperación.",
          i: "Activity",
        },
        {
          t: "Estrategia YAO",
          d: "Scalping de price action de convergencia direccional. Detección de vela de rechazo (continuación + reversión). Validación en cascada y entrada en el sentido del rechazo siguiendo la tendencia MTF.",
          i: "Target",
        },
        {
          t: "Estrategia MCB",
          d: "Swing trading de patrón chartista. Detección de velas de Momentum consecutivas. Entrada en el nivel de ruptura confirmado y validado por el Estocástico (opcional).",
          i: "Zap",
        },
        {
          t: "Estrategia CRT",
          d: "Swing trading de patrón chartista. Detección de la figura CRT. Entrada en modo agresivo o conservador para capturar el 100 % del potencial de la figura.",
          i: "CandlestickChart",
        },
        {
          t: "Estrategia LOKI",
          d: "Scalping de price action de alta frecuencia sobre reversión direccional. Detección y entrada en pullback en modo agresivo o conservador para capturar el potencial de los mercados volátiles.",
          i: "Repeat",
        },
        {
          t: "Estrategia THF Pulse",
          d: "Scalping de price action de alta frecuencia intra-vela. Detección de movimientos en dos tiempos sobre velas volátiles. Captura de impulsos para maximizar el beneficio.",
          i: "Waves",
        },
        // === Filas 2-3 — Módulos principales ===
        {
          t: "Multi-estrategia",
          d: "Modo Carrera o Relevo: STOKY, YAO, MCB, CRT, LOKI y THF Pulse pueden coexistir o turnarse después de una activación, con cooldown post-cambio.",
          i: "Workflow",
        },
        {
          t: "Exit Trade",
          d: "Limpieza inteligente de posiciones negativas: marcado por cambio de tendencia, cierra posiciones tóxicas para evitar pérdidas importantes y capturar la nueva tendencia lo antes posible.",
          i: "DoorOpen",
        },
        {
          t: "Risk Management",
          d: "Gestión de posiciones y órdenes STOP, filtro anti-ráfaga, cooldowns transaccionales, protección del nivel de margen, Daily Target Stop Trading, Profit Lock.",
          i: "ShieldCheck",
        },
        {
          t: "Copytrading Master / Slave",
          d: "Duplique automáticamente las operaciones de una cuenta Master en varias cuentas Slaves simultáneamente. Aislamiento multi-grupo seguro mediante Pairing Key única. Modos Idéntico / Invertido, lote Idéntico o local.",
          i: "Copy",
        },
        {
          t: "Interés compuesto",
          d: "Gestión dinámica de lotes: el EA ajusta automáticamente el tamaño de las posiciones según el capital disponible para capitalizar las ganancias. Modo de lote fijo también disponible.",
          i: "TrendingUp",
        },
        {
          t: "Telegram event-driven",
          d: "Notificaciones enriquecidas en tiempo real: operación abierta, operación cerrada con PNL/duración y eventos de Smart SL, …etc.",
          i: "Send",
        },
        {
          t: "Visualización en el gráfico",
          d: "Panel en el gráfico en tiempo real: umbrales Smart SL por posición, estado MTF del mercado, indicador RTA y panel de trading manual rápido.",
          i: "MonitorSmartphone",
        },
        // === Fila 4 — Filtros ===
        {
          t: "Filtro EZF",
          d: "Extreme Zone Filter: bloqueo direccional zonal basado en el Estocástico. Bloquea las compras en sobrecompra y las ventas en sobreventa en la TF de ejecución de cada estrategia.",
          i: "Lock",
        },
        {
          t: "Filtro RTA",
          d: "Reversal Trend Anticipation: detección de zonas de sobrecompra/sobreventa del Estocástico + divergencias RSI para anticipar las trampas de reversión.",
          i: "ShieldAlert",
        },
        {
          t: "Filtro MTF Price Action",
          d: "Validación de convergencia/divergencia multi-timeframe mediante puro análisis OHLC — filtro de tendencia fiable para optimizar las señales de las estrategias embarcadas.",
          i: "Layers",
        },
        {
          t: "Filtro 3MA",
          d: "Combinación de medias móviles configurada para filtrar las señales y favorecer un trading de seguimiento de tendencia o multidireccional según la elección del usuario.",
          i: "Filter",
        },
        {
          t: "Structure Filter",
          d: "Detección de pivotes swing (máximos/mínimos), trazado de zonas BUY/SELL en el gráfico. Permite BUY solo dentro de zonas alcistas, SELL solo dentro de zonas bajistas.",
          i: "Radar",
        },
      ],
      compare_overline: "¿POR QUÉ DR TRADE?",
      compare_title: "EA estándar vs. Dr Trade Scalper Pro",
      compare_sub: "Donde la mayoría de los EAs se detienen en una señal de entrada, el nuestro incorpora toda la cadena de protección.",
      compare_col_a: "EA estándar",
      compare_col_b: "Dr Trade Scalper Pro",
      compare_rows: [
        {
          topic: "Stop Loss",
          a: "SL fijo y ciego",
          b: "Smart SL adaptativo + trailing PNL para reducir la pérdida cerca del punto de equilibrio (break-even)",
        },
        {
          topic: "Filtro de tendencia",
          a: "A menudo ausente o de un solo timeframe",
          b: "MTF Price Action Semanal / Diario / H4 + filtro RTA Estocástico + RSI",
        },
        {
          topic: "Estrategias",
          a: "Una sola estrategia, poco adaptable",
          b: "STOKY + YAO + MCB + CRT + LOKI + THF Pulse en modo Carrera o Relevo con cooldown post-cambio",
        },
        {
          topic: "Límite de pérdida",
          a: "Hard SL fijo",
          b: "Hard Cap dinámico alineado automáticamente con el umbral Smart SL",
        },
        {
          topic: "Sobreoperación",
          a: "Sin salvaguardas",
          b: "Cooldown global + post-cambio + 60 min después de un cierre con Smart SL",
        },
        {
          topic: "Notificaciones",
          a: "Push básicas o inexistentes",
          b: "Notificaciones de Telegram por eventos: apertura, cierre (PNL/duración), eventos Smart SL",
        },
        {
          topic: "Validación de configuración",
          a: "Fallo silencioso si el lote es demasiado bajo",
          b: "Alerta emergente al cargar si el lote < mín. bróker",
        },
        {
          topic: "Lectura del contexto",
          a: "A adivinar en el gráfico",
          b: "Panel en el gráfico en tiempo real: umbrales SL, MTF, RTA, Estocástico TF_Position",
        },
        {
          topic: "Gestión de swaps",
          a: "Sin compensación",
          b: "TP Swap Compensation: desplazamiento automático del TP para compensar swap + comisión acumulados y preservar el beneficio neto previsto",
        },
      ],
    },
    faq: {
      overline: "FAQ",
      title: "Preguntas frecuentes",
      items: [
        {
          q: "¿Cómo se realiza la entrega después del pago?",
          a: "1) Usted paga a través de USDT, MobileMoney o Tarjeta Bancaria. 2) Rellena un formulario con su(s) número(s) de cuenta MT5. 3) Nuestro operador compila su archivo .ex5 personalizado en 5-15 minutos. 4) Recibe automáticamente el enlace de descarga.",
        },
        {
          q: "¿En qué bróker puedo usar el robot?",
          a: "Recomendados: Deriv, Weltrade, Exness, FBS, ... Todos los brókers que ofrezcan índices sintéticos, Forex, criptomonedas, metales e índices clásicos.",
        },
        {
          q: "¿El robot funciona en una cuenta demo?",
          a: "Sí, puede (y se lo recomendamos encarecidamente) probar nuestro EA en una cuenta demo antes de ponerlo en producción en una cuenta real. Proporcionará sus números de cuenta reales (demo y/o real) al realizar el pedido para que se vinculen a su licencia.",
        },
        {
          q: "¿Qué sucede si cambio de bróker o de número de cuenta?",
          a: "Contacte con soporte — es posible cambiar el número una vez durante la vigencia de la licencia (sujeto a justificación).",
        },
        {
          q: "¿Qué capital mínimo recomienda?",
          a: "500 USD mínimo en una cuenta real. Prefiera las cuentas ECN con spread bajo para optimizar el rendimiento.",
        },
        {
          q: "¿En qué mercados funciona el EA?",
          a: "El EA es multimercado. Funciona en índices sintéticos (Step Index, Boom/Crash, Volatility, BreakX, FxVol, …), pares de Forex mayores y menores, criptomonedas (BTCUSD, ETHUSD…), metales (Oro, Plata) e índices clásicos (US30, NAS100, SPX500…). Los parámetros por defecto son adecuados para un scalping en M1/M5; un ligero ajuste (TP/SL/trigger cooldown) puede ser útil dependiendo de la volatilidad del instrumento.",
        },
        {
          q: "¿Existe riesgo de pérdida?",
          a: "El trading conlleva un riesgo de pérdida de capital. El robot integra protecciones (Smart SL, RTA, filtros MTF), pero ningún sistema garantiza la ausencia de pérdidas. Invierta solo lo que pueda permitirse perder.",
        },
        {
          q: "¿Puedo obtener un reembolso?",
          a: "Dada la naturaleza digital del producto (archivo .ex5 personalizado), no es posible realizar reembolsos después de la entrega. Ofrecemos soporte técnico ilimitado durante la vigencia de la licencia.",
        },
        {
          q: "Mis órdenes STOP se posicionan demasiado lejos del precio actual y nunca se activan, ¿qué debo hacer?",
          a: "En algunos activos (pares exóticos, acciones CFD, índices sintéticos, activos con spread amplio), su bróker impone una distancia mínima obligatoria entre el precio actual y una orden pendiente (parámetro SYMBOL_TRADE_STOPS_LEVEL). Esta distancia puede superar el offset configurado en el EA, lo que impide que la orden se active y a veces genera el error 10015 (Invalid price). Para solucionar este problema: abra los inputs del EA, en la sección 3. Activación de estrategias, cambie el parámetro Ignore_Offset_Market_Entry a true. El robot abrirá entonces las posiciones directamente al precio de mercado (sin orden pendiente, sin offset), lo que evita la restricción del bróker. Deje este parámetro en false en brókers clásicos (ICMarkets, Exness, FTMO…) ya que el modo STOP + offset es más disciplinado y evita entradas en spikes.",
        },
      ],
    },
    tutorials: {
      overline: "TUTORIALES DE CONFIGURACIÓN",
      title: "Instale y configure el robot en 5 minutos",
      downloads_title: "Documentos para descargar",
      downloads_sub: "Guías oficiales en PDF (v1.24) — indispensables para una instalación y un uso óptimos.",
      download_install: "Guía de instalación",
      download_install_desc: "Procedimiento paso a paso para instalar, activar y configurar el EA en MT5",
      download_manual: "Manual de usuario",
      download_manual_desc: "Cómo usar el robot a diario: panel en el gráfico, parámetros, notificaciones de Telegram, FAQ",
      download_panel: "Guía del Panel de Configuración",
      download_panel_desc: "Detalle de las 17 secciones de inputs: LOT, AUTO, STOKY, YAO, MTF, RTA, Risk, Telegram, Smart SL, Hard Cap... con capturas de pantalla anotadas",
      download_cta: "Descargar PDF",
      download_size: "PDF · {size}",
      steps_title: "Pasos rápidos",
      steps: [
        {
          t: "1. Descargue el archivo .ex5",
          d: "Después de su pedido, recibirá un enlace de descarga seguro. El archivo es nominativo y está vinculado a sus números de cuenta MT5.",
        },
        {
          t: "2. Arrastre a la carpeta Experts de MT5",
          d: "Abra MetaEditor → menú File → Open Data Folder → MQL5 → Experts. Pegue su archivo .ex5 en esta carpeta.",
        },
        {
          t: "3. Reinicie MT5 y arrastre el EA al mercado que desea operar",
          d: "Abra un gráfico en M1 o M5, luego arrastre el EA desde el panel Navigator. Active «AutoTrading» en la barra de herramientas.",
        },
        {
          t: "4. Configure los parámetros",
          d: "Lote fijo o Compuesto, Telegram (token + chat ID), elección de estrategias (STOKY/YAO/Multi), filtro RTA. Los valores por defecto están optimizados.",
        },
        {
          t: "5. Supervise a través del panel y Telegram",
          d: "El robot muestra un panel de control en tiempo real en el gráfico. Reciba cada apertura/cierre de operación por Telegram.",
        },
      ],
      need_help: "¿Necesita ayuda? Contacte a nuestro soporte a través del chat a continuación.",
    },
  },
  de: {
    nav: {
      home: "Startseite",
      features: "Funktionen",
      pricing: "Preise",
      faq: "FAQ",
      tutorials: "Tutorials",
      affiliates: "Partnerprogramm",
      copytrading: "Copytrading",
      contact: "Kontakt",
      cta: "Bestellen",
    },
    common: {
      buy: "Kaufen",
      learn_more: "Mehr erfahren",
      get_started: "Jetzt starten",
      chat_with_us: "Mit uns chatten",
      back: "Zurück",
      next: "Weiter",
      submit: "Absenden",
      loading: "Laden…",
      currency: "FCFA",
      detection: "automatisch je nach Browser erkannt",
      yes: "Ja",
      no: "Nein",
      site_name: "Dr Trade Bots",
      required: "Erforderlich",
      optional: "Optional",
    },
    hero: {
      tagline: "EXPERT ADVISOR MT5 — SYNTHETISCHE INDIZES / FOREX / KRYPTOS",
      title: "Institutioneller Handel,",
      title_accent: "für Sie automatisiert.",
      sub: "Dr Trade Scalper Pro kombiniert sechs innovative, koexistierende Strategien (STOKY, YAO, MCB, CRT, LOKI, THF Pulse), einen RTA-Umkehrfilter, einen intelligenten Smart SL und einen Multi-Timeframe-Trendfilter. Entwickelt für anspruchsvolle, erfahrene oder neue Trader.",
      cta_primary: "Preise ansehen",
      cta_secondary: "Funktionen entdecken",
      stat1: "Koexistierende Strategien",
      stat2: "Einzigartige Funktionen",
      stat3: "Event-gesteuerte Telegram-Benachrichtigungen",
    },
    home: {
      cta_strip: {
        title_pre: "Bereit zum Scalpen mit ",
        title_accent: "institutioneller Präzision",
        title_post: "?",
        lead: "Eine maßgeschneiderte Kompilierung, in 5–15 Minuten geliefert, an Ihre MT5-Kontonummer gebunden — bei jedem Broker.",
        cta: "Preise ansehen",
      },
    },
    affiliates: {
      hdr_badge: "Partnerprogramm",
      hdr_title: "Empfehlen. Verdienen. Provisionen auszahlen lassen",
      hdr_lead_pre: "Teile deinen persönlichen Code. Für jeden Kauf oder jede Lizenzverlängerung über deinen Code erhältst du ",
      hdr_lead_emph: "bis zu 20 %",
      hdr_lead_post: " Provision — ausgezahlt in USDT oder Mobile Money.",
      tier_per_paid: "pro bezahlter Lizenz",
      tier_1: "1 — 500 Kunden",
      tier_2: "501 — 1.000 Kunden",
      tier_3: "1.001 Kunden und mehr",
      tab_signup: "Partner werden",
      tab_resend: "Meinen Code erhalten",
      tab_dashboard: "Mein Dashboard",
      signup_title: "Programmanmeldung",
      signup_lead: "Um Partner zu werden, musst du bereits Kunde sein. Wir überprüfen deinen Kauf automatisch anhand deiner E-Mail und Bestell-ID.",
      f_fullname: "Vollständiger Name",
      f_fullname_ph: "Max Mustermann",
      f_email: "E-Mail (die deiner Bestellung)",
      f_email_ph: "du@beispiel.com",
      f_order_id: "Bestell-ID (per E-Mail nach Kauf erhalten)",
      f_order_id_ph: "z. B.: 0fc8c401-6e30-4da1-b262-343380cba455",
      f_pay_method: "Auszahlungsmethode deiner Provisionen",
      f_usdt_addr: "USDT TRC20-Adresse",
      f_mm_num: "Mobile-Money-Nummer",
      btn_join: "Dem Programm beitreten",
      err_signup: "Anmeldefehler.",
      resend_title: "Meinen Partnercode erhalten",
      resend_lead: "Wenn du bereits angemeldet bist, gib deine E-Mail-Adresse an. Der Code wird an deine Adresse erneut gesendet.",
      resend_f_email: "Für die Partneranmeldung verwendete E-Mail",
      resend_f_order: "Bestell-ID (optional, aber sicherer)",
      resend_f_order_ph: "uuid-deiner-bestellung",
      resend_btn: "Meinen Code erneut senden",
      auth_title: "Mein Dashboard ansehen",
      auth_lead: "Gib deinen Partnercode und deine E-Mail ein, um deine Provisionen anzuzeigen.",
      f_code: "Partnercode",
      f_code_ph: "DTSP-XXXXXX",
      f_email_short: "E-Mail",
      btn_dashboard: "Mein Dashboard öffnen",
      err_creds: "Ungültige Anmeldedaten",
      subtab_overview: "Übersicht",
      subtab_referrals: "Empfehlungen",
      subtab_payouts: "Auszahlungen",
      subtab_marketing: "Marketing",
      hello: "Hallo",
      share_link_label: "Dein personalisierter Empfehlungslink",
      share_link_note: "Dieser Link füllt deinen Code automatisch im Checkout aus. 30 Tage im Browser des Besuchers gültig.",
      stat_clients: "Empfohlene einzigartige Kunden",
      stat_pending: "Ausstehende Provisionen",
      stat_paid: "Ausgezahlte Provisionen",
      commission_details: "Provisionsdetails",
      no_commission: "Noch keine Provisionen. Teile deinen Code!",
      col_order: "Bestellung",
      col_type: "Typ",
      col_client_num: "Kunde #",
      col_rate: "Satz",
      col_commission: "Provision",
      col_status: "Status",
      col_date: "Datum",
      type_renewal: "Verlängerung",
      type_new: "Neu",
      status_paid: "Bezahlt",
      status_pending: "Ausstehend",
      ref_title: "Deine Empfehlungen",
      ref_empty: "Noch keine Empfehlungen. Teile deinen Link!",
      ref_col_client: "Kunde",
      ref_col_plans: "Pläne",
      ref_col_orders: "Bestellungen",
      ref_col_renewal: "Verlängerung?",
      ref_col_cumul: "Gesamtprovisionen",
      ref_col_since: "Empfohlen seit",
      yes: "Ja",
      no: "Nein",
      loading: "Lädt…",
      err_generic: "Fehler",
      po_title: "Provisionen auszahlen",
      po_balance: "Verfügbares Guthaben:",
      po_processing: "Bearbeitungsdauer:",
      po_processing_days: "max. 7 Tage",
      po_threshold: "Mindestauszahlungsschwelle:",
      po_threshold_short_pre: " — Es fehlen dir noch ",
      po_threshold_short_post: " FCFA, um eine Auszahlung zu beantragen.",
      po_note: "Nachricht (optional)",
      po_note_ph: "Z. B.: dringende Überweisung",
      po_btn_request: "Auszahlung anfordern",
      po_btn_pending: "Anfrage läuft",
      po_btn_insufficient: "Guthaben zu gering",
      po_history: "Verlauf meiner Anfragen",
      po_history_empty: "Noch keine Anfragen.",
      po_col_amount: "Betrag",
      po_col_method: "Methode",
      po_col_wait: "Wartetage",
      po_col_paid_ref: "Zahlungsreferenz",
      po_st_pending: "Unbearbeitet",
      po_st_processing: "In Bearbeitung",
      po_st_paid: "Erledigt",
      po_st_rejected: "Abgelehnt",
      po_success: "Anfrage gesendet ✓ Bestätigungs-E-Mail versendet.",
      mk_title: "Deine Rabattcodes",
      mk_lead_pre: "Erstelle deine eigenen Promo-Codes, um dein Publikum zu boosten. Der Rabattsatz, den du gewährst, wird ",
      mk_lead_deducted: "abgezogen",
      mk_lead_mid: " von deiner Provision. Wenn du ",
      mk_lead_100: "100 %",
      mk_lead_post: " deines Satzes abgibst, erhältst du dennoch einen Bonus von 5 % auf den gezahlten Betrag.",
      mk_current_rate: "Dein aktueller Empfehlungssatz:",
      mk_max_discount: " — maximal zulässiger Rabatt:",
      mk_new: "Neuer Code",
      mk_cancel: "Abbrechen",
      mk_empty: "Noch keine Promo-Codes. Erstelle einen!",
      mk_col_code: "Code",
      mk_col_discount: "Rabatt",
      mk_col_validity: "Gültigkeit",
      mk_col_uses: "Nutzungen",
      mk_col_actions: "Aktionen",
      mk_active: "Aktiv",
      mk_inactive: "Deaktiviert",
      mk_btn_deactivate: "Deaktivieren",
      mk_btn_activate: "Aktivieren",
      mk_btn_delete: "Löschen",
      mk_confirm_del: "Code {code} endgültig löschen?",
      mk_f_code: "Code (optional, leer = automatisch)",
      mk_f_code_ph: "AFF-MEINCODE",
      mk_f_discount: "Rabatt (%) — max.",
      mk_f_from: "Gültig ab",
      mk_f_to: "Gültig bis",
      mk_f_uses: "Maximale Nutzungen (leer = unbegrenzt)",
      mk_f_uses_ph: "z. B.: 50",
      mk_create: "Code erstellen",
      su_title: "Willkommen im Programm!",
      su_code_label: "Dein Code",
      su_link_label: "Dein Empfehlungslink",
      su_copy_code: "Code kopieren",
      su_copy_link: "Link kopieren",
      su_copied: "Kopiert!",
      su_share_note: "Teile diesen Link über WhatsApp, Telegram oder Twitter — der Code wird in der Bestellung deiner Kontakte vorausgefüllt.",
      copy_my_code: "Meinen Code kopieren",
      copy: "Kopieren",
      copied: "Kopiert!",
    },
    pricing: {
      overline: "PREISE",
      title: "Wählen Sie Ihre Lizenz, aktivieren Sie Ihren EA in wenigen Stunden",
      sub: "Zahlung per USDT (TRC20), Mobile Money (Orange, MTN, Moov) oder PayPal. Nach Zahlungsbestätigung erfolgt die manuelle Lieferung per E-Mail innerhalb von maximal 24 Stunden (in der Regel innerhalb von 2 Stunden).",
      single: "Einzelkonto-Lizenz",
      single_sub: "2 autorisierte Konten (1 Demo + 1 Echtgeld)",
      multi: "Mehrfachkonto-Lizenz",
      multi_sub: "Bis zu 6 MT5-Konten",
      unlimited: "Unbegrenzte Lizenz",
      unlimited_sub: "Unbegrenzte Konten — keine Einschränkungen",
      duration_1m: "1 Monat",
      duration_3m: "3 Monate",
      duration_6m: "6 Monate",
      duration_12m: "12 Monate",
      save: "Sparen Sie",
      most_popular: "AM BELIEBTESTEN",
      cta: "Dieses Angebot wählen",
      includes: "Inklusive:",
      includes_list: [
        "Alle Strategien (STOKY + YAO + MCB + CRT + LOKI + THF Pulse)",
        "RTA-Filter + Smart SL + MTF-Filter",
        "Event-gesteuerte Telegram-Benachrichtigungen",
        "Updates während der Laufzeit",
        "Priorisierter technischer Support",
      ],
      note_single: "Ideal zum Testen, um den Testmonat gewinnbringend zu nutzen und dann eine längerfristige Investition zu tätigen",
      note_single_3m: "Für Trader, die zunächst ihr Kapital vermehren und danach eine langfristigere Investition tätigen möchten",
      note_single_6m: "Für Trader, die den Schritt zu einer mittelfristigen Investition wagen und ihr Kapital vermehren möchten",
      note_single_12m: "Für erfahrene Trader, die passives Einkommen erzielen und ihre Investition langfristig vermehren möchten",
      note_multi: "Für Trader mit mehreren Brokern oder Diversifikationsstrategien",
      note_unlimited: "Lizenz ohne Einschränkungen — Für Wiederverkäufer und Investmentgruppen",
      payment_methods: "Sichere Zahlungen · USDT (TRC20) · CinetPay · PayPal",
    },
    contact: {
      overline: "KONTAKT",
      title: "Haben Sie eine Frage? Schreiben Sie uns",
      sub: "Unser Team antwortet Ihnen innerhalb von 24 Geschäftsstunden. Für eine sofortige Antwort nutzen Sie den KI-Chat unten rechts.",
      name: "Vollständiger Name",
      email: "E-Mail",
      subject: "Betreff",
      message: "Ihre Nachricht",
      send: "Senden",
      sent: "Nachricht gesendet. Vielen Dank!",
    },
    checkout: {
      title: "Schließen Sie Ihre Bestellung ab",
      back_to_pricing: "Zurück zu den Preisen",
      promo_label: "Promo- oder Empfehlungscode (optional)",
      delivery_time: "Lieferung innerhalb von 24 Std. (in der Regel 2 Std.)",
      delivery_email: "Per E-Mail + PDF-Installationsanleitung",
      delivery_license: "Personalisierte Lizenz auf Ihren Namen",
      step_plan: "Ausgewählter Plan",
      step_info: "Ihre Informationen",
      step_payment: "Zahlung",
      step_confirm: "Bestätigung",
      summary: "Zusammenfassung",
      method: "Zahlungsmethode",
      full_name: "Vollständiger Name",
      email: "Liefer-E-Mail",
      phone: "Telefon (vorzugsweise WhatsApp)",
      broker: "Broker (optional)",
      mt5_accounts_label: "Autorisierte MT5-Konten",
      mt5_account_n: "MT5-Konto Nr.",
      mt5_demo: "Demokonto",
      mt5_live: "Echtgeldkonto",
      mt5_help_single: "Geben Sie Ihr Demokonto UND Ihr Echtgeldkonto ein (oder 2 Echtgeldkonten).",
      mt5_help_multi: "Geben Sie bis zu 6 MT5-Kontonummern ein.",
      mt5_help_unlimited: "Unbegrenzte Lizenz: keine Kontonummer erforderlich — auf all Ihren Konten nutzbar.",
      mt5_digits_only: "Kontonummer: nur Ziffern",
      payment_usdt: "USDT (TRC20)",
      payment_usdt_desc: "Krypto — nahezu sofortige Transaktion (~1 Min.)",
      payment_cinetpay: "CinetPay / Hub2",
      payment_cinetpay_desc: "Mobiles Geld Orange/MTN/Moov, Bankkarte",
      payment_paypal: "PayPal",
      payment_paypal_desc: "PayPal-Konto oder Karte über PayPal",
      payment_coming_soon: "Bald verfügbar",
      payment_instructions: "Zahlungsanweisungen",
      usdt_wallet: "USDT TRC20-Adresse",
      usdt_copy: "Adresse kopieren",
      usdt_copied: "Adresse kopiert!",
      usdt_qr: "QR-Code scannen",
      usdt_amount: "Exakter zu sendender Betrag",
      usdt_note: "⚠️ Senden Sie nur über das TRC20-Netzwerk (Tron). Jedes andere Netzwerk ist unwiederbringlich.",
      payment_reference: "Referenz / Transaktions-Hash",
      payment_reference_help: "TXID-Hash (USDT), PayPal-Transaktions-ID oder CinetPay-Referenz",
      usdt_hash_format: "Ungültiges Hash-Format: 64 hexadezimale Zeichen erforderlich (Tron TXID).",
      usdt_hash_help: "Der Hash wird automatisch auf der Tron-Blockchain überprüft, um den Betrag und den Empfänger vor der Bestellbestätigung zu verifizieren.",
      continue_to_payment: "Weiter zur Zahlung",
      back_to_info: "Meine Informationen bearbeiten",
      submit_order: "Meine Bestellung bestätigen",
      submitting: "Wird gesendet…",
      success_title: "Bestellung aufgegeben!",
      success_message: "Vielen Dank {name}! Ihre Bestellung Nr. {id} wurde aufgegeben. Nach Bestätigung Ihrer Zahlung (in der Regel innerhalb von 2 Stunden, maximal 24 Stunden) erhalten Sie Ihren personalisierten EA per E-Mail an {email}.",
      success_next_steps: "Nächste Schritte",
      success_step1: "Zahlungsüberprüfung durch unser Team",
      success_step2: "Kompilierung Ihrer personalisierten .ex5-Datei",
      success_step3: "Versand der .ex5-Datei + PDF-Anleitung per E-Mail",
      success_back_home: "Zurück zur Startseite",
      error_invalid: "Ungültiges Formular — bitte korrigieren Sie die Fehler",
      error_network: "Netzwerkfehler — bitte erneut versuchen",
    },
    chat: {
      title: "Dr Trade Assistent",
      placeholder: "Stellen Sie Ihre Frage…",
      placeholder_human: "Schreiben Sie unserem Support…",
      send: "Senden",
      welcome: "Hallo! Ich bin die Assistentin von Dr Trade Scalper Pro. Wie kann ich Ihnen helfen?",
      handoff: "Mit einem Menschen sprechen",
      handoff_modal: "Mit einem Menschen sprechen",
      handoff_first_name: "Vorname",
      handoff_last_name: "Nachname",
      handoff_email: "E-Mail-Adresse",
      handoff_telegram: "Telegram-Nummer/Benutzername (optional)",
      handoff_send: "Einen Mitarbeiter anfordern",
      send_photo: "Foto senden",
      handoff_sent: "Anfrage gesendet. Ein Mitarbeiter wird Sie in Kürze kontaktieren.",
      handoff_sending: "Verbindung zum Support wird hergestellt…",
      handoff_inline_btn: "Mit einem Menschen sprechen",
      handoff_cta_hint: "Bitte klicken Sie auf die Schaltfläche unten:",
      handoff_bridge_desc: "Ein Mitarbeiter wird Ihnen live in diesem Chat antworten. Hinterlassen Sie Ihre Kontaktdaten, damit er Sie bei Bedarf erneut kontaktieren kann.",
      handoff_bridge_start: "Mit dem Support verbinden",
      status_bot: "KI-Assistentin",
      status_human: "Menschlicher Support online",
      end_bridge: "Schließen",
      bridge_connected: "✅ Sie sind jetzt mit unserem Support verbunden. Schreiben Sie Ihre Nachricht – ein Mitarbeiter wird Ihnen direkt antworten.",
      bridge_closed: "🔒 Ihre Konversation mit dem Support ist beendet. Die KI-Assistentin hat wieder übernommen.",
      bridge_ended_visitor: "🔒 Sie haben die Konversation mit dem Support beendet.",
      typing: "Die Assistentin schreibt…",
      notif_enable: "Aktivieren Sie Benachrichtigungen, um keine Antworten zu verpassen",
      notif_title_alert: "Neue Nachricht!",
      notif_os_title: "Dr Trade — Support antwortet Ihnen",
    },
    footer: {
      tagline: "Der Premium-EA, der Ihnen 100 % passives Einkommen generiert,\nautomatisiert und sicher.",
      legal: "Der Handel birgt ein hohes Verlustrisiko und ist nicht für alle Anleger geeignet. Durch die Nutzung unseres EA bleiben Sie allein für Ihre Gewinne oder Verluste verantwortlich.",
      copy: "© 2026 Dr Trade. Alle Rechte vorbehalten.",
      disclaimer: "Risikohinweis",
      payments_accepted: "Akzeptierte Zahlungen",
    },
    features: {
      overline: "FUNKTIONEN",
      title: "Eine komplette Toolbox für stressfreies Trading",
      sub: "Jedes Modul ist darauf ausgelegt, Marktgeräusche zu reduzieren, Fehlsignale zu filtern und Ihr Kapital zu schützen.",
      list: [
        // === Zeile 1 — Strategien ===
        {
          t: "STOKY-Strategie",
          d: "Trendfolge-Scalping mit Fokus auf die Wertzone des Preises. Punktgenaue Einstiege in Impuls-/Korrekturphasen, mit oder ohne MTF-Filter. Anti-Overtrading-Cooldown.",
          i: "Activity",
        },
        {
          t: "YAO-Strategie",
          d: "Price-Action-Scalping mit direktionaler Konvergenz. Erkennung von Ablehnungskerzen (Fortsetzung + Umkehr). Kaskadierte Validierung und Einstieg in Richtung der Ablehnung im Einklang mit dem MTF-Trend.",
          i: "Target",
        },
        {
          t: "MCB-Strategie",
          d: "Swing-Trading auf Chartmuster. Erkennung aufeinanderfolgender Momentum-Kerzen. Einstieg auf dem bestätigten Ausbruchsniveau, validiert durch den Stochastik (optional).",
          i: "Zap",
        },
        {
          t: "CRT-Strategie",
          d: "Swing-Trading auf Chartmuster. Erkennung der CRT-Figur. Aggressiver oder konservativer Einstieg, um 100 % des Figur-Potenzials zu erfassen.",
          i: "CandlestickChart",
        },
        {
          t: "LOKI-Strategie",
          d: "Hochfrequenz-Price-Action-Scalping auf direktionale Umkehr. Erkennung und Einstieg beim Pullback im aggressiven oder konservativen Modus, um das Potenzial volatiler Märkte zu erfassen.",
          i: "Repeat",
        },
        {
          t: "THF Pulse-Strategie",
          d: "Hochfrequenz-Intra-Kerzen-Price-Action-Scalping. Erkennung von zweistufigen Bewegungen in volatilen Kerzen. Erfassung von Impulsen zur Gewinnmaximierung.",
          i: "Waves",
        },
        // === Zeilen 2-3 — Kernmodule ===
        {
          t: "Multi-Strategie",
          d: "Race- oder Relay-Modus: STOKY, YAO, MCB, CRT, LOKI und THF Pulse können koexistieren oder sich nach einer Auslösung abwechseln, mit Post-Switch-Cooldown.",
          i: "Workflow",
        },
        {
          t: "Exit Trade",
          d: "Intelligente Bereinigung von Verlustpositionen: Markierung bei Trendwechsel, schließt toxische Positionen um schwere Verluste zu vermeiden und den neuen Trend frühzeitig zu erfassen.",
          i: "DoorOpen",
        },
        {
          t: "Risikomanagement",
          d: "Positions- und STOP-Order-Management, Anti-Burst-Filter, transaktionale Cooldowns, Schutz des Margin-Niveaus, Daily Target Stop Trading, Profit Lock.",
          i: "ShieldCheck",
        },
        {
          t: "Master / Slave Copytrading",
          d: "Dupliziert Trades von einem Master-Konto automatisch auf mehrere Slave-Konten gleichzeitig. Sichere Multi-Gruppen-Isolation durch einzigartige Pairing Key. Modi Identisch / Invertiert, Lot Identisch oder lokal.",
          i: "Copy",
        },
        {
          t: "Zinseszins",
          d: "Dynamisches Lot-Management: Der EA passt die Positionsgröße automatisch an das verfügbare Kapital an, um Gewinne zu kapitalisieren. Festes Lot-Modus ebenfalls verfügbar.",
          i: "TrendingUp",
        },
        {
          t: "Ereignisgesteuertes Telegram",
          d: "Umfassende Echtzeit-Benachrichtigungen: Trade eröffnet, Trade geschlossen mit PNL/Dauer und Smart-SL-Ereignisse, …etc.",
          i: "Send",
        },
        {
          t: "Grafische Anzeige",
          d: "Echtzeit-On-Chart-Panel: Smart-SL-Schwellenwerte pro Position, MTF-Marktzustand, RTA-Indikator und ein schnelles manuelles Trading-Panel.",
          i: "MonitorSmartphone",
        },
        // === Zeile 4 — Filter ===
        {
          t: "EZF-Filter",
          d: "Extreme Zone Filter: direktionale Zonensperre basierend auf dem Stochastik. Blockiert BUYs in überkauften und SELLs in überverkauften Zonen auf der Ausführungs-TF jeder Strategie.",
          i: "Lock",
        },
        {
          t: "RTA-Filter",
          d: "Reversal Trend Anticipation: Erkennung von überkauften/überverkauften Stochastik-Zonen + RSI-Divergenzen, um Umkehrfallen zu antizipieren.",
          i: "ShieldAlert",
        },
        {
          t: "MTF Price Action Filter",
          d: "Multi-Zeitrahmen Konvergenz-/Divergenz-Validierung durch reine OHLC-Analyse — zuverlässiger Trendfilter zur Optimierung der Signale der eingebauten Strategien.",
          i: "Layers",
        },
        {
          t: "3MA-Filter",
          d: "Kombination gleitender Durchschnitte, konfiguriert um Signale zu filtern und je nach Wahl des Nutzers ein trendfolgendes oder multidirektionales Trading zu begünstigen.",
          i: "Filter",
        },
        {
          t: "Structure Filter",
          d: "Swing-Pivot-Erkennung (Hochs/Tiefs), On-Chart BUY/SELL-Zonenzeichnung. BUYs nur in bullischen Zonen erlaubt, SELLs nur in bärischen Zonen.",
          i: "Radar",
        },
      ],
      compare_overline: "WARUM DR TRADE?",
      compare_title: "Standard-EA vs. Dr Trade Scalper Pro",
      compare_sub: "Wo die meisten EAs bei einem Einstiegssignal aufhören, bietet unserer die gesamte Schutzkette.",
      compare_col_a: "Standard-EA",
      compare_col_b: "Dr Trade Scalper Pro",
      compare_rows: [
        {
          topic: "Stop Loss",
          a: "Fester und blinder SL",
          b: "Adaptiver Smart SL + PNL-Trailing zur Verlustreduzierung nahe dem Break-even",
        },
        {
          topic: "Trendfilter",
          a: "Oft nicht vorhanden oder nur für eine Zeiteinheit",
          b: "MTF Price Action Wöchentlich / Täglich / H4 + RTA-Filter Stochastik + RSI",
        },
        {
          topic: "Strategien",
          a: "Eine einzige, wenig anpassungsfähige Strategie",
          b: "STOKY + YAO + MCB + CRT + LOKI + THF Pulse im Race- oder Relay-Modus mit Post-Switch-Cooldown",
        },
        {
          topic: "Verlustobergrenze",
          a: "Fester Hard SL",
          b: "Dynamischer Hard Cap, automatisch an die Smart SL-Schwelle angepasst",
        },
        {
          topic: "Overtrading",
          a: "Keine Schutzmechanismen",
          b: "Globaler Cooldown + Post-Switch + 60 Min. nach einem Smart SL-Schluss",
        },
        {
          topic: "Benachrichtigungen",
          a: "Einfache oder keine Push-Benachrichtigungen",
          b: "Ereignisgesteuertes Telegram: Eröffnung, Schließung (PNL/Dauer), Smart SL-Ereignisse",
        },
        {
          topic: "Konfigurationsprüfung",
          a: "Stiller Fehler bei zu niedrigem Lot",
          b: "Warn-Popup beim Laden, wenn Lot < Broker-Minimum",
        },
        {
          topic: "Kontextanalyse",
          a: "Muss aus dem Chart erraten werden",
          b: "Echtzeit-On-Chart-Panel: SL-Schwellen, MTF, RTA, Stochastik TF_Position",
        },
        {
          topic: "Swap-Management",
          a: "Keine Kompensation",
          b: "TP Swap Compensation: automatische TP-Verschiebung zur Kompensation kumulierter Swaps + Kommissionen und zum Erhalt des angestrebten Nettoprofits",
        },
      ],
    },
    faq: {
      overline: "FAQ",
      title: "Häufig gestellte Fragen",
      items: [
        {
          q: "Wie erfolgt die Lieferung nach der Zahlung?",
          a: "1) Sie zahlen per USDT, MobileMoney oder Kreditkarte. 2) Sie füllen ein Formular mit Ihrer/Ihren MT5-Kontonummer(n) aus. 3) Unser Operator kompiliert Ihre personalisierte .ex5-Datei in 5-15 Minuten. 4) Sie erhalten automatisch den Download-Link.",
        },
        {
          q: "Bei welchem Broker kann ich den Roboter verwenden?",
          a: "Empfohlen: Deriv, Weltrade, Exness, FBS, ... Alle Broker, die synthetische Indizes, Forex, Kryptowährungen, Metalle und klassische Indizes anbieten.",
        },
        {
          q: "Funktioniert der Roboter auf einem Demokonto?",
          a: "Ja, Sie können (und wir empfehlen es dringend) unseren EA auf einem Demokonto testen, bevor Sie ihn auf einem Live-Konto einsetzen. Sie geben bei der Bestellung Ihre echten Kontonummern (Demo und/oder Live) an, damit diese mit Ihrer Lizenz verknüpft werden.",
        },
        {
          q: "Was passiert, wenn ich den Broker oder die Kontonummer wechsle?",
          a: "Kontaktieren Sie den Support — ein Wechsel der Kontonummer ist einmal während der Lizenzlaufzeit möglich (Begründung erforderlich).",
        },
        {
          q: "Welches Mindestkapital empfehlen Sie?",
          a: "Mindestens 500 USD auf einem Live-Konto. Bevorzugen Sie ECN-Konten mit niedrigem Spread, um die Leistung zu optimieren.",
        },
        {
          q: "Auf welchen Märkten funktioniert der EA?",
          a: "Der EA ist für mehrere Märkte geeignet. Er funktioniert auf synthetischen Indizes (Step Index, Boom/Crash, Volatility, BreakX, FxVol, …), großen und kleinen Forex-Paaren, Kryptowährungen (BTCUSD, ETHUSD…), Metallen (Gold, Silber) und klassischen Indizes (US30, NAS100, SPX500…). Die Standardeinstellungen sind für M1/M5-Scalping geeignet; eine leichte Anpassung (TP/SL/Trigger-Cooldown) kann je nach Volatilität des Instruments sinnvoll sein.",
        },
        {
          q: "Besteht ein Verlustrisiko?",
          a: "Trading birgt ein Kapitalverlustrisiko. Der Roboter verfügt über Schutzmechanismen (Smart SL, RTA, MTF-Filter), aber kein System kann Verluste vollständig ausschließen. Investieren Sie nur Kapital, dessen Verlust Sie sich leisten können.",
        },
        {
          q: "Kann ich eine Rückerstattung erhalten?",
          a: "Aufgrund der digitalen Natur des Produkts (personalisierte .ex5-Datei) ist nach der Lieferung keine Rückerstattung möglich. Wir bieten unbegrenzten technischen Support für die Dauer der Lizenz.",
        },
        {
          q: "Meine STOP-Orders werden zu weit vom aktuellen Preis entfernt platziert und nie ausgelöst – was tun?",
          a: "Bei bestimmten Vermögenswerten (exotische Paare, Aktien-CFDs, synthetische Indizes, Vermögenswerte mit hohem Spread) schreibt Ihr Broker einen obligatorischen Mindestabstand zwischen dem aktuellen Kurs und einer schwebenden Order vor (Parameter SYMBOL_TRADE_STOPS_LEVEL). Dieser Abstand kann den im EA konfigurierten Offset überschreiten, was die Auslösung der Order verhindert und manchmal den Fehler 10015 (Invalid price) erzeugt. Um dieses Problem zu beheben: Öffnen Sie die Inputs des EA, gehen Sie zu Abschnitt 3. Aktivierung der Strategien und setzen Sie den Parameter Ignore_Offset_Market_Entry auf true. Der Roboter eröffnet dann Positionen direkt zum Marktpreis (ohne schwebende Order, ohne Offset), was die Broker-Beschränkung umgeht. Lassen Sie diesen Parameter bei klassischen Brokern (ICMarkets, Exness, FTMO…) auf false, da der STOP + offset-Modus disziplinierter bleibt und Einstiege bei Spikes vermeidet.",
        },
      ],
    },
    tutorials: {
      overline: "KONFIGURATIONS-TUTORIALS",
      title: "Installieren und konfigurieren Sie den Roboter in 5 Minuten",
      downloads_title: "Dokumente zum Herunterladen",
      downloads_sub: "Offizielle PDF-Anleitungen (v1.24) – unerlässlich für eine optimale Installation und Nutzung.",
      download_install: "Installationsanleitung",
      download_install_desc: "Schritt-für-Schritt-Anleitung zur Installation, Aktivierung und Konfiguration des EA in MT5",
      download_manual: "Benutzerhandbuch",
      download_manual_desc: "So verwenden Sie den Roboter im Alltag: On-Chart-Panel, Einstellungen, Telegram-Benachrichtigungen, FAQ",
      download_panel: "Anleitung zum Konfigurationspanel",
      download_panel_desc: "Details zu den 17 Input-Bereichen: LOT, AUTO, STOKY, YAO, MTF, RTA, Risk, Telegram, Smart SL, Hard Cap... mit kommentierten Screenshots",
      download_cta: "PDF herunterladen",
      download_size: "PDF · {size}",
      steps_title: "Schnelle Schritte",
      steps: [
        {
          t: "1. Laden Sie die .ex5-Datei herunter",
          d: "Nach Ihrer Bestellung erhalten Sie einen sicheren Download-Link. Die Datei ist personalisiert und mit Ihren MT5-Kontonummern verknüpft.",
        },
        {
          t: "2. Ziehen Sie die Datei in den MT5-Expertenordner",
          d: "Öffnen Sie MetaEditor → Menü File → Open Data Folder → MQL5 → Experts. Fügen Sie Ihre .ex5-Datei in diesen Ordner ein.",
        },
        {
          t: "3. Starten Sie MT5 neu und ziehen Sie den EA auf den Chart des Marktes, den Sie handeln möchten",
          d: "Öffnen Sie einen M1- oder M5-Chart und ziehen Sie dann den EA aus dem Navigator-Panel darauf. Aktivieren Sie „AutoTrading“ in der Symbolleiste.",
        },
        {
          t: "4. Konfigurieren Sie die Einstellungen",
          d: "Festes Lot oder Compound, Telegram (Token + Chat-ID), Strategieauswahl (STOKY/YAO/Multi), RTA-Filter. Die Standardwerte sind optimiert.",
        },
        {
          t: "5. Überwachen Sie über das Panel und Telegram",
          d: "Der Roboter zeigt ein Echtzeit-Dashboard auf dem Chart an. Erhalten Sie jede Trade-Eröffnung/-Schließung per Telegram.",
        },
      ],
      need_help: "Benötigen Sie Hilfe? Kontaktieren Sie unseren Support über den Chat unten.",
    },
  },
};

const I18nCtx = createContext({ t: (k) => k, lang: "fr", setLang: () => {} });

function detectInitialLang() {
  if (typeof window === "undefined") return "fr";
  const stored = localStorage.getItem("dtsp_lang");
  if (["fr", "en", "es", "de"].includes(stored)) return stored;
  const nav = (navigator.language || navigator.userLanguage || "fr").toLowerCase();
  if (nav.startsWith("en")) return "en";
  if (nav.startsWith("es")) return "es";
  if (nav.startsWith("de")) return "de";
  return "fr";
}

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(detectInitialLang);
  useEffect(() => {
    localStorage.setItem("dtsp_lang", lang);
    // Met à jour <html lang="..."> pour le SEO (Google + lecteurs d'écran)
    if (typeof document !== "undefined") {
      document.documentElement.setAttribute("lang", lang);
    }
  }, [lang]);

  // Fallback hierarchy: target lang → fr (UI source of truth)
  // ES/DE not yet fully translated on UI strings, so fallback to FR keeps the
  // site usable while the chat AI replies natively in the chosen language.
  const t = (key) => {
    const parts = key.split(".");
    const tryDict = (d) => {
      let cur = d;
      for (const p of parts) {
        if (cur && typeof cur === "object" && p in cur) cur = cur[p];
        else return undefined;
      }
      return cur;
    };
    const v = tryDict(dict[lang]);
    if (v !== undefined) return v;
    const fb = tryDict(dict.fr);
    return fb !== undefined ? fb : key;
  };

  return (
    <I18nCtx.Provider value={{ t, lang, setLang }}>{children}</I18nCtx.Provider>
  );
}

export const useI18n = () => useContext(I18nCtx);
